var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _g, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _g2, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _g3, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _g4, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _g5, _path642, _path643, _rect, _rect2, _rect3, _rect4, _rect5, _path644, _rect6, _path645, _rect7, _rect8, _rect9, _path646, _path647, _rect0, _rect1, _rect10, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _g6, _path667, _rect11, _g7, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _rect12, _path683, _path684, _path685, _path686, _path687, _path688, _g8, _path689, _path690, _g9, _path691, _path692, _g0, _path693, _path694, _g1, _path695, _path696, _g10, _path697, _path698, _g11, _path699, _path700, _path701, _path702;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 763.709,
    height: 635.816,
    viewBox: "0 0 763.709 635.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2305",
    "data-name": "Rectangle 2305",
    width: 763.709,
    height: 635.817,
    transform: "translate(0 88)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2276",
    "data-name": "Rectangle 2276",
    width: 53.014,
    height: 352.944,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2277",
    "data-name": "Rectangle 2277",
    width: 52.053,
    height: 296.162,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2278",
    "data-name": "Rectangle 2278",
    width: 53.621,
    height: 380.739,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2279",
    "data-name": "Rectangle 2279",
    width: 74.567,
    height: 405.167,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2280",
    "data-name": "Rectangle 2280",
    width: 15.432,
    height: 62.494,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28358",
    "data-name": "Path 28358",
    d: "M255.782,75.149c-2.792,0-123.892-.934-151.1,12.129C79.991,99.133,49.03,189.461,43.392,206.463c30.282,2.039,180.915,12.079,212.39,12.079,30.915,0,182.05-10.04,212.393-12.083-5.642-17-36.6-107.326-61.293-119.181-23.81-11.43-119.529-12.144-144.937-12.144-3.622,0-5.812.015-6.163.015",
    transform: "translate(-43.392 -75.134)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2294",
    "data-name": "Rectangle 2294",
    width: 45.5,
    height: 25.707,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2296",
    "data-name": "Rectangle 2296",
    width: 25.022,
    height: 14.03,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2304",
    "data-name": "Rectangle 2304",
    width: 763.709,
    height: 723.817,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2298",
    "data-name": "Rectangle 2298",
    width: 230.374,
    height: 4.23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2299",
    "data-name": "Rectangle 2299",
    width: 226.335,
    height: 4.102,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2300",
    "data-name": "Rectangle 2300",
    width: 219.641,
    height: 3.889,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2301",
    "data-name": "Rectangle 2301",
    width: 210.48,
    height: 3.647,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2302",
    "data-name": "Rectangle 2302",
    width: 197.042,
    height: 3.363,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2303",
    "data-name": "Rectangle 2303",
    width: 242.079,
    height: 143.167,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10302",
    "data-name": "Group 10302",
    transform: "translate(0 -88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10301",
    "data-name": "Group 10301",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10272",
    "data-name": "Group 10272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10271",
    "data-name": "Group 10271",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27668",
    "data-name": "Path 27668",
    d: "M129.041,147.96H6.246v-59.5a8.819,8.819,0,0,1,8.82-8.82H120.222a8.819,8.819,0,0,1,8.82,8.82Z",
    transform: "translate(17.873 227.886)",
    fill: "#eff1fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27669",
    "data-name": "Path 27669",
    d: "M115.892,147.96H25.746v-59.5a8.818,8.818,0,0,1,8.816-8.82h72.511a8.819,8.819,0,0,1,8.82,8.82Z",
    transform: "translate(73.672 227.886)",
    fill: "#bec4fa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27670",
    "data-name": "Path 27670",
    d: "M158.676,405.322V91.843a2.584,2.584,0,0,0-2.479-2.676H4.317a2.581,2.581,0,0,0-2.479,2.676V405.322Z",
    transform: "translate(5.259 255.15)",
    fill: "#eff1fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27671",
    "data-name": "Path 27671",
    d: "M145.527,405.322V91.843a2.584,2.584,0,0,0-2.479-2.676H23.817a2.581,2.581,0,0,0-2.479,2.676V405.322Z",
    transform: "translate(61.058 255.15)",
    fill: "#bec4fa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27672",
    "data-name": "Path 27672",
    d: "M31.95,114.17h0a8.306,8.306,0,0,1-8.306-8.306V99.635a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(67.657 261.337)",
    fill: "#e5e7f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27673",
    "data-name": "Path 27673",
    d: "M28.652,91.329h-2a3.135,3.135,0,0,1,2.989,3.263v16.315a3.135,3.135,0,0,1-2.989,3.263h2a3.135,3.135,0,0,0,2.985-3.263V94.592a3.135,3.135,0,0,0-2.985-3.263",
    transform: "translate(76.276 261.337)",
    fill: "#f8f9fd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27674",
    "data-name": "Path 27674",
    d: "M39.642,114.17h0a8.306,8.306,0,0,1-8.306-8.306V99.635a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 261.337)",
    fill: "#e5e7f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27675",
    "data-name": "Path 27675",
    d: "M36.342,91.329H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V94.592a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 261.337)",
    fill: "#f8f9fd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27676",
    "data-name": "Path 27676",
    d: "M39.642,114.17h0a8.306,8.306,0,0,1-8.306-8.306V99.635a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 261.337)",
    fill: "#e5e7f2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27677",
    "data-name": "Path 27677",
    d: "M36.342,91.329H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V94.592a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 261.337)",
    fill: "#f8f9fd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27678",
    "data-name": "Path 27678",
    d: "M47.335,114.17h0a8.306,8.306,0,0,1-8.306-8.306V99.635a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(111.681 261.337)",
    fill: "#e5e7f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27679",
    "data-name": "Path 27679",
    d: "M44.034,91.329H42.041a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V94.592a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(120.3 261.337)",
    fill: "#f8f9fd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27680",
    "data-name": "Path 27680",
    d: "M55.027,114.17h0a8.306,8.306,0,0,1-8.306-8.306V99.635a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(133.692 261.337)",
    fill: "#e5e7f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27681",
    "data-name": "Path 27681",
    d: "M51.727,91.329H49.734a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V94.592a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(142.313 261.337)",
    fill: "#f8f9fd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27682",
    "data-name": "Path 27682",
    d: "M31.95,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(67.657 295.214)",
    fill: "#e5e7f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27683",
    "data-name": "Path 27683",
    d: "M28.652,103.168h-2a3.135,3.135,0,0,1,2.989,3.263v16.315a3.135,3.135,0,0,1-2.989,3.263h2a3.135,3.135,0,0,0,2.985-3.263V106.431a3.135,3.135,0,0,0-2.985-3.263",
    transform: "translate(76.276 295.214)",
    fill: "#f8f9fd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27684",
    "data-name": "Path 27684",
    d: "M39.642,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 295.214)",
    fill: "#e5e7f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27685",
    "data-name": "Path 27685",
    d: "M36.342,103.168H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V106.431a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 295.214)",
    fill: "#f8f9fd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27686",
    "data-name": "Path 27686",
    d: "M39.642,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 295.214)",
    fill: "#e5e7f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27687",
    "data-name": "Path 27687",
    d: "M36.342,103.168H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V106.431a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 295.214)",
    fill: "#f8f9fd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27688",
    "data-name": "Path 27688",
    d: "M47.335,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(111.681 295.214)",
    fill: "#e5e7f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27689",
    "data-name": "Path 27689",
    d: "M44.034,103.168H42.041a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V106.431a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(120.3 295.214)",
    fill: "#f8f9fd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27690",
    "data-name": "Path 27690",
    d: "M55.027,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(133.692 295.214)",
    fill: "#e5e7f2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27691",
    "data-name": "Path 27691",
    d: "M51.727,103.168H49.734a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V106.431a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(142.313 295.214)",
    fill: "#f8f9fd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27692",
    "data-name": "Path 27692",
    d: "M31.95,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(67.657 295.214)",
    fill: "#e5e7f2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27693",
    "data-name": "Path 27693",
    d: "M28.652,103.168h-2a3.135,3.135,0,0,1,2.989,3.263v16.315a3.135,3.135,0,0,1-2.989,3.263h2a3.135,3.135,0,0,0,2.985-3.263V106.431a3.135,3.135,0,0,0-2.985-3.263",
    transform: "translate(76.276 295.214)",
    fill: "#f8f9fd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27694",
    "data-name": "Path 27694",
    d: "M39.642,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 295.214)",
    fill: "#e5e7f2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27695",
    "data-name": "Path 27695",
    d: "M36.342,103.168H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V106.431a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 295.214)",
    fill: "#f8f9fd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27696",
    "data-name": "Path 27696",
    d: "M39.642,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 295.214)",
    fill: "#e5e7f2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27697",
    "data-name": "Path 27697",
    d: "M36.342,103.168H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V106.431a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 295.214)",
    fill: "#f8f9fd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27698",
    "data-name": "Path 27698",
    d: "M47.335,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(111.681 295.214)",
    fill: "#e5e7f2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27699",
    "data-name": "Path 27699",
    d: "M44.034,103.168H42.041a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V106.431a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(120.3 295.214)",
    fill: "#f8f9fd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27700",
    "data-name": "Path 27700",
    d: "M55.027,126.009h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0V117.7a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(133.692 295.214)",
    fill: "#e5e7f2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27701",
    "data-name": "Path 27701",
    d: "M51.727,103.168H49.734a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V106.431a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(142.313 295.214)",
    fill: "#f8f9fd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27702",
    "data-name": "Path 27702",
    d: "M31.95,137.848h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(67.657 329.091)",
    fill: "#e5e7f2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27703",
    "data-name": "Path 27703",
    d: "M28.652,115.006h-2a3.135,3.135,0,0,1,2.989,3.263v16.315a3.135,3.135,0,0,1-2.989,3.263h2a3.135,3.135,0,0,0,2.985-3.263V118.269a3.135,3.135,0,0,0-2.985-3.263",
    transform: "translate(76.276 329.088)",
    fill: "#f8f9fd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27704",
    "data-name": "Path 27704",
    d: "M39.642,137.848h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 329.091)",
    fill: "#e5e7f2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27705",
    "data-name": "Path 27705",
    d: "M36.342,115.006H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V118.269a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 329.088)",
    fill: "#f8f9fd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27706",
    "data-name": "Path 27706",
    d: "M39.642,137.848h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 329.091)",
    fill: "#e5e7f2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27707",
    "data-name": "Path 27707",
    d: "M36.342,115.006H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V118.269a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 329.088)",
    fill: "#f8f9fd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27708",
    "data-name": "Path 27708",
    d: "M47.335,137.848h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(111.681 329.091)",
    fill: "#e5e7f2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27709",
    "data-name": "Path 27709",
    d: "M44.034,115.006H42.041a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V118.269a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(120.3 329.088)",
    fill: "#f8f9fd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27710",
    "data-name": "Path 27710",
    d: "M55.027,137.848h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(133.692 329.091)",
    fill: "#e5e7f2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27711",
    "data-name": "Path 27711",
    d: "M51.727,115.006H49.734a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V118.269a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(142.313 329.088)",
    fill: "#f8f9fd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27712",
    "data-name": "Path 27712",
    d: "M31.95,149.686h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(67.657 362.965)",
    fill: "#e5e7f2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27713",
    "data-name": "Path 27713",
    d: "M28.652,126.845h-2a3.135,3.135,0,0,1,2.989,3.263v16.315a3.135,3.135,0,0,1-2.989,3.263h2a3.135,3.135,0,0,0,2.985-3.263V130.108a3.135,3.135,0,0,0-2.985-3.263",
    transform: "translate(76.276 362.965)",
    fill: "#f8f9fd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27714",
    "data-name": "Path 27714",
    d: "M39.642,149.686h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 362.965)",
    fill: "#e5e7f2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27715",
    "data-name": "Path 27715",
    d: "M36.342,126.845H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V130.108a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 362.965)",
    fill: "#f8f9fd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27716",
    "data-name": "Path 27716",
    d: "M39.642,149.686h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 362.965)",
    fill: "#e5e7f2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27717",
    "data-name": "Path 27717",
    d: "M36.342,126.845H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V130.108a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 362.965)",
    fill: "#f8f9fd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27718",
    "data-name": "Path 27718",
    d: "M47.335,149.686h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(111.681 362.965)",
    fill: "#e5e7f2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27719",
    "data-name": "Path 27719",
    d: "M44.034,126.845H42.041a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V130.108a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(120.3 362.965)",
    fill: "#f8f9fd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27720",
    "data-name": "Path 27720",
    d: "M55.027,149.686h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(133.692 362.965)",
    fill: "#e5e7f2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27721",
    "data-name": "Path 27721",
    d: "M51.727,126.845H49.734a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V130.108a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(142.313 362.965)",
    fill: "#f8f9fd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27722",
    "data-name": "Path 27722",
    d: "M31.95,161.525h0a8.306,8.306,0,0,1-8.306-8.306V146.99a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(67.657 396.843)",
    fill: "#e5e7f2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27723",
    "data-name": "Path 27723",
    d: "M28.652,138.684h-2a3.135,3.135,0,0,1,2.989,3.263v16.315a3.135,3.135,0,0,1-2.989,3.263h2a3.135,3.135,0,0,0,2.985-3.263V141.947a3.135,3.135,0,0,0-2.985-3.263",
    transform: "translate(76.276 396.843)",
    fill: "#f8f9fd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27724",
    "data-name": "Path 27724",
    d: "M39.642,161.525h0a8.306,8.306,0,0,1-8.306-8.306V146.99a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 396.843)",
    fill: "#e5e7f2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27725",
    "data-name": "Path 27725",
    d: "M36.342,138.684H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V141.947a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 396.843)",
    fill: "#f8f9fd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27726",
    "data-name": "Path 27726",
    d: "M39.642,161.525h0a8.306,8.306,0,0,1-8.306-8.306V146.99a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 396.843)",
    fill: "#e5e7f2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27727",
    "data-name": "Path 27727",
    d: "M36.342,138.684H34.349a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V141.947a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 396.843)",
    fill: "#f8f9fd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27728",
    "data-name": "Path 27728",
    d: "M47.335,161.525h0a8.306,8.306,0,0,1-8.306-8.306V146.99a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(111.681 396.843)",
    fill: "#e5e7f2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27729",
    "data-name": "Path 27729",
    d: "M44.034,138.684H42.041a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V141.947a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(120.3 396.843)",
    fill: "#f8f9fd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27730",
    "data-name": "Path 27730",
    d: "M55.027,161.525h0a8.306,8.306,0,0,1-8.306-8.306V146.99a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(133.692 396.843)",
    fill: "#e5e7f2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27731",
    "data-name": "Path 27731",
    d: "M51.727,138.684H49.734a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V141.947a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(142.313 396.843)",
    fill: "#f8f9fd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27732",
    "data-name": "Path 27732",
    d: "M31.95,173.364h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(67.657 430.72)",
    fill: "#e5e7f2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27733",
    "data-name": "Path 27733",
    d: "M28.652,150.523h-2a3.135,3.135,0,0,1,2.989,3.263V170.1a3.135,3.135,0,0,1-2.989,3.263h2a3.135,3.135,0,0,0,2.985-3.263V153.786a3.135,3.135,0,0,0-2.985-3.263",
    transform: "translate(76.276 430.72)",
    fill: "#f8f9fd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27734",
    "data-name": "Path 27734",
    d: "M39.642,173.364h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 430.72)",
    fill: "#e5e7f2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27735",
    "data-name": "Path 27735",
    d: "M36.342,150.523H34.349a3.132,3.132,0,0,1,2.985,3.263V170.1a3.132,3.132,0,0,1-2.985,3.263h1.993A3.135,3.135,0,0,0,39.33,170.1V153.786a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 430.72)",
    fill: "#f8f9fd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27736",
    "data-name": "Path 27736",
    d: "M39.642,173.364h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 430.72)",
    fill: "#e5e7f2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27737",
    "data-name": "Path 27737",
    d: "M36.342,150.523H34.349a3.132,3.132,0,0,1,2.985,3.263V170.1a3.132,3.132,0,0,1-2.985,3.263h1.993A3.135,3.135,0,0,0,39.33,170.1V153.786a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 430.72)",
    fill: "#f8f9fd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27738",
    "data-name": "Path 27738",
    d: "M47.335,173.364h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(111.681 430.72)",
    fill: "#e5e7f2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27739",
    "data-name": "Path 27739",
    d: "M44.034,150.523H42.041a3.132,3.132,0,0,1,2.985,3.263V170.1a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V153.786a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(120.3 430.72)",
    fill: "#f8f9fd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27740",
    "data-name": "Path 27740",
    d: "M55.027,173.364h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(133.692 430.72)",
    fill: "#e5e7f2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27741",
    "data-name": "Path 27741",
    d: "M51.727,150.523H49.734a3.132,3.132,0,0,1,2.985,3.263V170.1a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V153.786a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(142.313 430.72)",
    fill: "#f8f9fd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27742",
    "data-name": "Path 27742",
    d: "M31.95,185.2h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V176.9A8.306,8.306,0,0,1,31.95,185.2",
    transform: "translate(67.657 464.597)",
    fill: "#e5e7f2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27743",
    "data-name": "Path 27743",
    d: "M28.652,162.362h-2a3.135,3.135,0,0,1,2.989,3.263V181.94a3.135,3.135,0,0,1-2.989,3.263h2a3.135,3.135,0,0,0,2.985-3.263V165.625a3.135,3.135,0,0,0-2.985-3.263",
    transform: "translate(76.276 464.597)",
    fill: "#f8f9fd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27744",
    "data-name": "Path 27744",
    d: "M39.642,185.2h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V176.9a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 464.597)",
    fill: "#e5e7f2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27745",
    "data-name": "Path 27745",
    d: "M36.342,162.362H34.349a3.132,3.132,0,0,1,2.985,3.263V181.94a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.625a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 464.597)",
    fill: "#f8f9fd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27746",
    "data-name": "Path 27746",
    d: "M39.642,185.2h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V176.9a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(89.668 464.597)",
    fill: "#e5e7f2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27747",
    "data-name": "Path 27747",
    d: "M36.342,162.362H34.349a3.132,3.132,0,0,1,2.985,3.263V181.94a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.625a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(98.289 464.597)",
    fill: "#f8f9fd"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27748",
    "data-name": "Path 27748",
    d: "M47.335,185.2h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V176.9a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(111.681 464.597)",
    fill: "#e5e7f2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27749",
    "data-name": "Path 27749",
    d: "M44.034,162.362H42.041a3.132,3.132,0,0,1,2.985,3.263V181.94a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.625a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(120.3 464.597)",
    fill: "#f8f9fd"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27750",
    "data-name": "Path 27750",
    d: "M55.027,185.2h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0V176.9a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(133.692 464.597)",
    fill: "#e5e7f2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27751",
    "data-name": "Path 27751",
    d: "M51.727,162.362H49.734a3.132,3.132,0,0,1,2.985,3.263V181.94a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.625a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(142.313 464.597)",
    fill: "#f8f9fd"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27752",
    "data-name": "Path 27752",
    d: "M21.148,114.17h0a8.306,8.306,0,0,0,8.306-8.306V99.635a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(36.747 261.337)",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27753",
    "data-name": "Path 27753",
    d: "M15.83,91.329h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H15.83a3.135,3.135,0,0,1-2.989-3.263V94.592a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(36.744 261.337)",
    fill: "#bec4fa"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27754",
    "data-name": "Path 27754",
    d: "M13.455,114.17h0a8.306,8.306,0,0,0,8.306-8.306V99.635a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 261.337)",
    fill: "#e5e7f2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27755",
    "data-name": "Path 27755",
    d: "M8.141,91.329h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V94.592a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 261.337)",
    fill: "#f8f9fd"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27756",
    "data-name": "Path 27756",
    d: "M13.455,114.17h0a8.306,8.306,0,0,0,8.306-8.306V99.635a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 261.337)",
    fill: "#fff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27757",
    "data-name": "Path 27757",
    d: "M8.141,91.329h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V94.592a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 261.337)",
    fill: "#bec4fa"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27758",
    "data-name": "Path 27758",
    d: "M21.148,126.111h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0V117.8a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(36.747 295.506)",
    fill: "#fff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27759",
    "data-name": "Path 27759",
    d: "M15.83,103.27h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H15.83a3.135,3.135,0,0,1-2.989-3.263V106.533a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(36.744 295.506)",
    fill: "#bec4fa"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27760",
    "data-name": "Path 27760",
    d: "M13.455,126.111h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0V117.8a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 295.506)",
    fill: "#e5e7f2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27761",
    "data-name": "Path 27761",
    d: "M8.141,103.27h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V106.533a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 295.506)",
    fill: "#f8f9fd"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27762",
    "data-name": "Path 27762",
    d: "M13.455,126.111h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0V117.8a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 295.506)",
    fill: "#fff"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27763",
    "data-name": "Path 27763",
    d: "M8.141,103.27h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V106.533a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 295.506)",
    fill: "#bec4fa"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27764",
    "data-name": "Path 27764",
    d: "M21.148,126.111h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0V117.8a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(36.747 295.506)",
    fill: "#fff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27765",
    "data-name": "Path 27765",
    d: "M15.83,103.27h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H15.83a3.135,3.135,0,0,1-2.989-3.263V106.533a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(36.744 295.506)",
    fill: "#bec4fa"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27766",
    "data-name": "Path 27766",
    d: "M13.455,126.111h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0V117.8a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 295.506)",
    fill: "#e5e7f2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27767",
    "data-name": "Path 27767",
    d: "M8.141,103.27h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V106.533a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 295.506)",
    fill: "#f8f9fd"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27768",
    "data-name": "Path 27768",
    d: "M13.455,126.111h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0V117.8a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 295.506)",
    fill: "#fff"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27769",
    "data-name": "Path 27769",
    d: "M8.141,103.27h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V106.533a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 295.506)",
    fill: "#bec4fa"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27770",
    "data-name": "Path 27770",
    d: "M21.148,138.053h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,1,0-16.612,0v6.229a8.3,8.3,0,0,0,8.306,8.306",
    transform: "translate(36.747 329.678)",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27771",
    "data-name": "Path 27771",
    d: "M15.83,115.212h1.993a3.132,3.132,0,0,0-2.985,3.263V134.79a3.132,3.132,0,0,0,2.985,3.263H15.83a3.135,3.135,0,0,1-2.989-3.263V118.475a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(36.744 329.678)",
    fill: "#bec4fa"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27772",
    "data-name": "Path 27772",
    d: "M13.455,138.053h0a8.309,8.309,0,0,0,8.31-8.306v-6.229a8.308,8.308,0,0,0-16.616,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 329.678)",
    fill: "#e5e7f2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27773",
    "data-name": "Path 27773",
    d: "M8.141,115.212h1.989a3.132,3.132,0,0,0-2.985,3.263V134.79a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V118.475a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 329.678)",
    fill: "#f8f9fd"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27774",
    "data-name": "Path 27774",
    d: "M13.455,138.053h0a8.309,8.309,0,0,0,8.31-8.306v-6.229a8.308,8.308,0,0,0-16.616,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 329.678)",
    fill: "#fff"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27775",
    "data-name": "Path 27775",
    d: "M8.141,115.212h1.989a3.132,3.132,0,0,0-2.985,3.263V134.79a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V118.475a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 329.678)",
    fill: "#bec4fa"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27776",
    "data-name": "Path 27776",
    d: "M21.148,149.995h0a8.306,8.306,0,0,0,8.306-8.306V135.46a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(36.747 363.85)",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27777",
    "data-name": "Path 27777",
    d: "M15.83,127.154h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H15.83a3.135,3.135,0,0,1-2.989-3.263V130.417a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(36.744 363.85)",
    fill: "#bec4fa"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27778",
    "data-name": "Path 27778",
    d: "M13.455,149.995h0a8.306,8.306,0,0,0,8.306-8.306V135.46a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 363.85)",
    fill: "#e5e7f2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27779",
    "data-name": "Path 27779",
    d: "M8.141,127.154h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V130.417a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 363.85)",
    fill: "#f8f9fd"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27780",
    "data-name": "Path 27780",
    d: "M13.455,149.995h0a8.306,8.306,0,0,0,8.306-8.306V135.46a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 363.85)",
    fill: "#fff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27781",
    "data-name": "Path 27781",
    d: "M8.141,127.154h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V130.417a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 363.85)",
    fill: "#bec4fa"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27782",
    "data-name": "Path 27782",
    d: "M21.148,161.936h0a8.306,8.306,0,0,0,8.306-8.306V147.4a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(36.747 398.019)",
    fill: "#fff"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27783",
    "data-name": "Path 27783",
    d: "M15.83,139.1h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H15.83a3.135,3.135,0,0,1-2.989-3.263V142.358A3.135,3.135,0,0,1,15.83,139.1",
    transform: "translate(36.744 398.019)",
    fill: "#bec4fa"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27784",
    "data-name": "Path 27784",
    d: "M13.455,161.936h0a8.306,8.306,0,0,0,8.306-8.306V147.4a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 398.019)",
    fill: "#e5e7f2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27785",
    "data-name": "Path 27785",
    d: "M8.141,139.1h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V142.358A3.138,3.138,0,0,1,8.141,139.1",
    transform: "translate(14.731 398.019)",
    fill: "#f8f9fd"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27786",
    "data-name": "Path 27786",
    d: "M13.455,161.936h0a8.306,8.306,0,0,0,8.306-8.306V147.4a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 398.019)",
    fill: "#fff"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27787",
    "data-name": "Path 27787",
    d: "M8.141,139.1h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V142.358A3.138,3.138,0,0,1,8.141,139.1",
    transform: "translate(14.731 398.019)",
    fill: "#bec4fa"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27788",
    "data-name": "Path 27788",
    d: "M21.148,173.878h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(36.747 432.19)",
    fill: "#fff"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27789",
    "data-name": "Path 27789",
    d: "M15.83,151.037h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H15.83a3.135,3.135,0,0,1-2.989-3.263V154.3a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(36.744 432.19)",
    fill: "#bec4fa"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27790",
    "data-name": "Path 27790",
    d: "M13.455,173.878h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 432.19)",
    fill: "#e5e7f2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27791",
    "data-name": "Path 27791",
    d: "M8.141,151.037h1.989A3.132,3.132,0,0,0,7.144,154.3v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V154.3a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 432.19)",
    fill: "#f8f9fd"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27792",
    "data-name": "Path 27792",
    d: "M13.455,173.878h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 432.19)",
    fill: "#fff"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27793",
    "data-name": "Path 27793",
    d: "M8.141,151.037h1.989A3.132,3.132,0,0,0,7.144,154.3v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V154.3a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 432.19)",
    fill: "#bec4fa"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27794",
    "data-name": "Path 27794",
    d: "M21.148,185.819h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(36.747 466.359)",
    fill: "#fff"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27795",
    "data-name": "Path 27795",
    d: "M15.83,162.978h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H15.83a3.135,3.135,0,0,1-2.989-3.263V166.241a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(36.744 466.359)",
    fill: "#bec4fa"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27796",
    "data-name": "Path 27796",
    d: "M13.455,185.819h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 466.359)",
    fill: "#e5e7f2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27797",
    "data-name": "Path 27797",
    d: "M8.141,162.978h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V166.241a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 466.359)",
    fill: "#f8f9fd"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27798",
    "data-name": "Path 27798",
    d: "M13.455,185.819h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(14.734 466.359)",
    fill: "#fff"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27799",
    "data-name": "Path 27799",
    d: "M8.141,162.978h1.989a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H8.141a3.138,3.138,0,0,1-2.993-3.263V166.241a3.138,3.138,0,0,1,2.993-3.263",
    transform: "translate(14.731 466.359)",
    fill: "#bec4fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10258",
    "data-name": "Group 10258",
    transform: "translate(153.571 307.529)",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10257",
    "data-name": "Group 10257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10256",
    "data-name": "Group 10256",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27800",
    "data-name": "Path 27800",
    d: "M92.784,432.584V119.1a2.584,2.584,0,0,0-2.479-2.676H75.763v-34.1A2.586,2.586,0,0,0,73.3,79.64H39.77V432.584Z",
    transform: "translate(-39.769 -79.64)",
    fill: "#bec4fa"
  }))))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27801",
    "data-name": "Path 27801",
    d: "M278.382,390.506V96.531a2.11,2.11,0,0,0-2.027-2.186H152.308a2.11,2.11,0,0,0-2.027,2.186V390.506Z",
    transform: "translate(430.027 269.967)",
    fill: "#eff1fd"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27802",
    "data-name": "Path 27802",
    d: "M267.641,390.506V96.531a2.11,2.11,0,0,0-2.027-2.186H168.234a2.11,2.11,0,0,0-2.027,2.186V390.506Z",
    transform: "translate(475.599 269.967)",
    fill: "#bec4fa"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27803",
    "data-name": "Path 27803",
    d: "M174.876,152.623h0a6.786,6.786,0,0,1-6.785-6.785V102.895a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(480.99 275.018)",
    fill: "#e5e7f2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27804",
    "data-name": "Path 27804",
    d: "M172.181,96.111h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V98.775a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(488.029 275.02)",
    fill: "#f8f9fd"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27805",
    "data-name": "Path 27805",
    d: "M250.4,119.4H171.89a3.8,3.8,0,1,1,0-7.592H250.4a3.8,3.8,0,0,1,0,7.592",
    transform: "translate(480.987 319.951)",
    fill: "#e5e7f2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27806",
    "data-name": "Path 27806",
    d: "M190.964,111.814h-1.63a2.56,2.56,0,0,1,2.441,2.664v2.259a2.561,2.561,0,0,1-2.441,2.668h1.63a2.561,2.561,0,0,0,2.44-2.668v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.777 319.954)",
    fill: "#f8f9fd"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27807",
    "data-name": "Path 27807",
    d: "M181.159,152.623h0a6.784,6.784,0,0,1-6.785-6.785V102.895a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 275.018)",
    fill: "#e5e7f2"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27808",
    "data-name": "Path 27808",
    d: "M178.464,96.111h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V98.775a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 275.02)",
    fill: "#f8f9fd"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27809",
    "data-name": "Path 27809",
    d: "M181.159,152.623h0a6.784,6.784,0,0,1-6.785-6.785V102.895a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 275.018)",
    fill: "#e5e7f2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27810",
    "data-name": "Path 27810",
    d: "M178.464,96.111h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V98.775a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 275.02)",
    fill: "#f8f9fd"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27811",
    "data-name": "Path 27811",
    d: "M187.441,152.623h0a6.786,6.786,0,0,1-6.785-6.785V102.895a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(516.945 275.018)",
    fill: "#e5e7f2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27812",
    "data-name": "Path 27812",
    d: "M184.747,96.111h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V98.775a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(523.987 275.02)",
    fill: "#f8f9fd"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27813",
    "data-name": "Path 27813",
    d: "M193.724,152.623h0a6.786,6.786,0,0,1-6.785-6.785V102.895a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(534.924 275.018)",
    fill: "#e5e7f2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27814",
    "data-name": "Path 27814",
    d: "M191.03,96.111H189.4a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V98.775a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.966 275.02)",
    fill: "#f8f9fd"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27815",
    "data-name": "Path 27815",
    d: "M174.876,171.868h0a6.786,6.786,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(480.99 330.087)",
    fill: "#e5e7f2"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27816",
    "data-name": "Path 27816",
    d: "M172.181,115.356h-1.63a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(488.029 330.09)",
    fill: "#f8f9fd"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27817",
    "data-name": "Path 27817",
    d: "M250.4,138.65H171.89a3.8,3.8,0,1,1,0-7.592H250.4a3.8,3.8,0,0,1,0,7.592",
    transform: "translate(480.987 375.021)",
    fill: "#e5e7f2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27818",
    "data-name": "Path 27818",
    d: "M190.964,131.059h-1.63a2.56,2.56,0,0,1,2.441,2.664v2.259a2.561,2.561,0,0,1-2.441,2.668h1.63a2.561,2.561,0,0,0,2.44-2.668v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.777 375.024)",
    fill: "#f8f9fd"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27819",
    "data-name": "Path 27819",
    d: "M181.159,171.868h0a6.786,6.786,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 330.087)",
    fill: "#e5e7f2"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27820",
    "data-name": "Path 27820",
    d: "M178.464,115.356h-1.63a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 330.09)",
    fill: "#f8f9fd"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27821",
    "data-name": "Path 27821",
    d: "M181.159,171.868h0a6.786,6.786,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 330.087)",
    fill: "#e5e7f2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27822",
    "data-name": "Path 27822",
    d: "M178.464,115.356h-1.63a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 330.09)",
    fill: "#f8f9fd"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27823",
    "data-name": "Path 27823",
    d: "M187.441,171.868h0a6.786,6.786,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(516.945 330.087)",
    fill: "#e5e7f2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27824",
    "data-name": "Path 27824",
    d: "M184.747,115.356h-1.63a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(523.987 330.09)",
    fill: "#f8f9fd"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27825",
    "data-name": "Path 27825",
    d: "M193.724,171.868h0a6.784,6.784,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(534.924 330.087)",
    fill: "#e5e7f2"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27826",
    "data-name": "Path 27826",
    d: "M191.03,115.356H189.4a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.966 330.09)",
    fill: "#f8f9fd"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27827",
    "data-name": "Path 27827",
    d: "M174.876,171.868h0a6.786,6.786,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(480.99 330.087)",
    fill: "#e5e7f2"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27828",
    "data-name": "Path 27828",
    d: "M172.181,115.356h-1.63a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(488.029 330.09)",
    fill: "#f8f9fd"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27829",
    "data-name": "Path 27829",
    d: "M250.4,138.65H171.89a3.8,3.8,0,1,1,0-7.592H250.4a3.8,3.8,0,0,1,0,7.592",
    transform: "translate(480.987 375.021)",
    fill: "#e5e7f2"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27830",
    "data-name": "Path 27830",
    d: "M190.964,131.059h-1.63a2.56,2.56,0,0,1,2.441,2.664v2.259a2.561,2.561,0,0,1-2.441,2.668h1.63a2.561,2.561,0,0,0,2.44-2.668v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.777 375.024)",
    fill: "#f8f9fd"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27831",
    "data-name": "Path 27831",
    d: "M181.159,171.868h0a6.786,6.786,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 330.087)",
    fill: "#e5e7f2"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27832",
    "data-name": "Path 27832",
    d: "M178.464,115.356h-1.63a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 330.09)",
    fill: "#f8f9fd"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27833",
    "data-name": "Path 27833",
    d: "M181.159,171.868h0a6.786,6.786,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 330.087)",
    fill: "#e5e7f2"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27834",
    "data-name": "Path 27834",
    d: "M178.464,115.356h-1.63a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 330.09)",
    fill: "#f8f9fd"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27835",
    "data-name": "Path 27835",
    d: "M187.441,171.868h0a6.786,6.786,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(516.945 330.087)",
    fill: "#e5e7f2"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27836",
    "data-name": "Path 27836",
    d: "M184.747,115.356h-1.63a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(523.987 330.09)",
    fill: "#f8f9fd"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27837",
    "data-name": "Path 27837",
    d: "M193.724,171.868h0a6.784,6.784,0,0,1-6.785-6.785V122.14a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(534.924 330.087)",
    fill: "#e5e7f2"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27838",
    "data-name": "Path 27838",
    d: "M191.03,115.356H189.4a2.56,2.56,0,0,1,2.44,2.664V169.2a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V118.02a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.966 330.09)",
    fill: "#f8f9fd"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27839",
    "data-name": "Path 27839",
    d: "M174.876,191.114h0a6.786,6.786,0,0,1-6.785-6.785V141.386a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(480.99 385.159)",
    fill: "#e5e7f2"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27840",
    "data-name": "Path 27840",
    d: "M172.181,134.6h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V137.265a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(488.029 385.159)",
    fill: "#f8f9fd"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27841",
    "data-name": "Path 27841",
    d: "M250.4,157.895H171.887a3.8,3.8,0,1,1,0-7.592H250.4a3.8,3.8,0,1,1,0,7.592",
    transform: "translate(480.99 430.09)",
    fill: "#e5e7f2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27842",
    "data-name": "Path 27842",
    d: "M190.964,150.3h-1.63a2.56,2.56,0,0,1,2.441,2.664v2.259a2.561,2.561,0,0,1-2.441,2.668h1.63a2.561,2.561,0,0,0,2.44-2.668v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.777 430.093)",
    fill: "#f8f9fd"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27843",
    "data-name": "Path 27843",
    d: "M181.159,191.114h0a6.786,6.786,0,0,1-6.785-6.785V141.386a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 385.159)",
    fill: "#e5e7f2"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27844",
    "data-name": "Path 27844",
    d: "M178.464,134.6h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V137.265a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 385.159)",
    fill: "#f8f9fd"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27845",
    "data-name": "Path 27845",
    d: "M181.159,191.114h0a6.786,6.786,0,0,1-6.785-6.785V141.386a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 385.159)",
    fill: "#e5e7f2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27846",
    "data-name": "Path 27846",
    d: "M178.464,134.6h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V137.265a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 385.159)",
    fill: "#f8f9fd"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27847",
    "data-name": "Path 27847",
    d: "M187.441,191.114h0a6.786,6.786,0,0,1-6.785-6.785V141.386a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(516.945 385.159)",
    fill: "#e5e7f2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27848",
    "data-name": "Path 27848",
    d: "M184.747,134.6h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V137.265a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(523.987 385.159)",
    fill: "#f8f9fd"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27849",
    "data-name": "Path 27849",
    d: "M193.724,191.114h0a6.786,6.786,0,0,1-6.785-6.785V141.386a6.785,6.785,0,0,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(534.924 385.159)",
    fill: "#e5e7f2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27850",
    "data-name": "Path 27850",
    d: "M191.03,134.6H189.4a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V137.265a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.966 385.159)",
    fill: "#f8f9fd"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27851",
    "data-name": "Path 27851",
    d: "M174.876,210.359h0a6.786,6.786,0,0,1-6.785-6.785V160.631a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(480.99 440.228)",
    fill: "#e5e7f2"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27852",
    "data-name": "Path 27852",
    d: "M172.181,153.846h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V156.51a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(488.029 440.228)",
    fill: "#f8f9fd"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27853",
    "data-name": "Path 27853",
    d: "M254.058,175.31a2.863,2.863,0,0,0,.135-.838v-2.259a2.56,2.56,0,0,0-2.44-2.664H170.53a2.56,2.56,0,0,0-2.44,2.664v2.259a2.863,2.863,0,0,0,.135.838Z",
    transform: "translate(480.987 485.162)",
    fill: "#e5e7f2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27854",
    "data-name": "Path 27854",
    d: "M191.775,172.213v2.259a2.821,2.821,0,0,1-.135.838h1.63a2.821,2.821,0,0,0,.135-.838v-2.259a2.56,2.56,0,0,0-2.44-2.664h-1.63a2.56,2.56,0,0,1,2.44,2.664",
    transform: "translate(541.78 485.162)",
    fill: "#f8f9fd"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27855",
    "data-name": "Path 27855",
    d: "M181.159,210.359h0a6.786,6.786,0,0,1-6.785-6.785V160.631a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 440.228)",
    fill: "#e5e7f2"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27856",
    "data-name": "Path 27856",
    d: "M178.464,153.846h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V156.51a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 440.228)",
    fill: "#f8f9fd"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27857",
    "data-name": "Path 27857",
    d: "M181.159,210.359h0a6.786,6.786,0,0,1-6.785-6.785V160.631a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(498.969 440.228)",
    fill: "#e5e7f2"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27858",
    "data-name": "Path 27858",
    d: "M178.464,153.846h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V156.51a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(506.008 440.228)",
    fill: "#f8f9fd"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27859",
    "data-name": "Path 27859",
    d: "M187.442,210.359h0a6.784,6.784,0,0,1-6.785-6.785V160.631a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(516.948 440.228)",
    fill: "#e5e7f2"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27860",
    "data-name": "Path 27860",
    d: "M184.747,153.846h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V156.51a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(523.987 440.228)",
    fill: "#f8f9fd"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27861",
    "data-name": "Path 27861",
    d: "M193.724,210.359h0a6.786,6.786,0,0,1-6.785-6.785V160.631a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(534.924 440.228)",
    fill: "#e5e7f2"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27862",
    "data-name": "Path 27862",
    d: "M191.03,153.846H189.4a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V156.51a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(541.966 440.228)",
    fill: "#f8f9fd"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27863",
    "data-name": "Path 27863",
    d: "M166.11,152.623h0a6.786,6.786,0,0,0,6.785-6.785V102.895a6.785,6.785,0,0,0-13.569,0v42.944a6.787,6.787,0,0,0,6.785,6.785",
    transform: "translate(455.906 275.018)",
    fill: "#fff"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27864",
    "data-name": "Path 27864",
    d: "M161.766,96.111h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.441-2.664V98.775a2.56,2.56,0,0,1,2.441-2.664",
    transform: "translate(455.906 275.02)",
    fill: "#bec4fa"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27865",
    "data-name": "Path 27865",
    d: "M156.768,119.4h30.513a3.8,3.8,0,1,0,0-7.592H156.768a3.8,3.8,0,0,0,0,7.592",
    transform: "translate(437.727 319.951)",
    fill: "#fff"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27866",
    "data-name": "Path 27866",
    d: "M155.412,111.813h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.561,2.561,0,0,0,2.44,2.668h-1.63a2.561,2.561,0,0,1-2.44-2.668v-2.259a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.727 319.951)",
    fill: "#bec4fa"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27867",
    "data-name": "Path 27867",
    d: "M159.827,152.623h0a6.784,6.784,0,0,0,6.785-6.785V102.9a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 275.018)",
    fill: "#e5e7f2"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27868",
    "data-name": "Path 27868",
    d: "M155.482,96.111h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V98.775a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 275.02)",
    fill: "#f8f9fd"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27869",
    "data-name": "Path 27869",
    d: "M159.827,152.623h0a6.784,6.784,0,0,0,6.785-6.785V102.9a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 275.018)",
    fill: "#fff"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27870",
    "data-name": "Path 27870",
    d: "M155.482,96.111h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V98.775a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 275.02)",
    fill: "#bec4fa"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27871",
    "data-name": "Path 27871",
    d: "M166.11,171.929h0a6.786,6.786,0,0,0,6.785-6.785V122.2a6.785,6.785,0,1,0-13.569,0v42.94a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(455.906 330.261)",
    fill: "#fff"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27872",
    "data-name": "Path 27872",
    d: "M161.766,115.416h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.441-2.664V118.08a2.56,2.56,0,0,1,2.441-2.664",
    transform: "translate(455.906 330.261)",
    fill: "#bec4fa"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27873",
    "data-name": "Path 27873",
    d: "M156.767,138.707H187.28a3.794,3.794,0,1,0,0-7.588H156.767a3.794,3.794,0,1,0,0,7.588",
    transform: "translate(437.725 375.195)",
    fill: "#fff"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27874",
    "data-name": "Path 27874",
    d: "M155.412,131.119h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.558,2.558,0,0,0,2.44,2.664h-1.63a2.558,2.558,0,0,1-2.44-2.664v-2.259a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.727 375.195)",
    fill: "#bec4fa"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27875",
    "data-name": "Path 27875",
    d: "M159.827,171.929h0a6.786,6.786,0,0,0,6.785-6.785V122.2a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 330.261)",
    fill: "#e5e7f2"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27876",
    "data-name": "Path 27876",
    d: "M155.482,115.416h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V118.08a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 330.261)",
    fill: "#f8f9fd"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27877",
    "data-name": "Path 27877",
    d: "M159.827,171.929h0a6.786,6.786,0,0,0,6.785-6.785V122.2a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 330.261)",
    fill: "#fff"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27878",
    "data-name": "Path 27878",
    d: "M155.482,115.416h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V118.08a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 330.261)",
    fill: "#bec4fa"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27879",
    "data-name": "Path 27879",
    d: "M166.11,171.929h0a6.786,6.786,0,0,0,6.785-6.785V122.2a6.785,6.785,0,1,0-13.569,0v42.94a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(455.906 330.261)",
    fill: "#fff"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27880",
    "data-name": "Path 27880",
    d: "M161.766,115.416h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.441-2.664V118.08a2.56,2.56,0,0,1,2.441-2.664",
    transform: "translate(455.906 330.261)",
    fill: "#bec4fa"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27881",
    "data-name": "Path 27881",
    d: "M156.767,138.707H187.28a3.794,3.794,0,1,0,0-7.588H156.767a3.794,3.794,0,1,0,0,7.588",
    transform: "translate(437.725 375.195)",
    fill: "#fff"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27882",
    "data-name": "Path 27882",
    d: "M155.412,131.119h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.558,2.558,0,0,0,2.44,2.664h-1.63a2.558,2.558,0,0,1-2.44-2.664v-2.259a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.727 375.195)",
    fill: "#bec4fa"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27883",
    "data-name": "Path 27883",
    d: "M159.827,171.929h0a6.786,6.786,0,0,0,6.785-6.785V122.2a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 330.261)",
    fill: "#e5e7f2"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27884",
    "data-name": "Path 27884",
    d: "M155.482,115.416h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V118.08a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 330.261)",
    fill: "#f8f9fd"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27885",
    "data-name": "Path 27885",
    d: "M159.827,171.929h0a6.786,6.786,0,0,0,6.785-6.785V122.2a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 330.261)",
    fill: "#fff"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27886",
    "data-name": "Path 27886",
    d: "M155.482,115.416h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V118.08a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 330.261)",
    fill: "#bec4fa"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27887",
    "data-name": "Path 27887",
    d: "M166.11,191.234h0a6.786,6.786,0,0,0,6.785-6.785V141.506a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(455.906 385.502)",
    fill: "#fff"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27888",
    "data-name": "Path 27888",
    d: "M161.766,134.721h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.441-2.664V137.385a2.56,2.56,0,0,1,2.441-2.664",
    transform: "translate(455.906 385.502)",
    fill: "#bec4fa"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27889",
    "data-name": "Path 27889",
    d: "M156.767,158.016H187.28a3.794,3.794,0,1,0,0-7.588l-30.514,0a3.8,3.8,0,0,0,0,7.592",
    transform: "translate(437.725 430.436)",
    fill: "#fff"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27890",
    "data-name": "Path 27890",
    d: "M155.412,150.424h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.561,2.561,0,0,0,2.44,2.668h-1.63a2.561,2.561,0,0,1-2.44-2.668v-2.259a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.727 430.436)",
    fill: "#bec4fa"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27891",
    "data-name": "Path 27891",
    d: "M159.827,191.234h0a6.786,6.786,0,0,0,6.785-6.785V141.506a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 385.502)",
    fill: "#e5e7f2"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27892",
    "data-name": "Path 27892",
    d: "M155.482,134.721h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V137.385a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 385.502)",
    fill: "#f8f9fd"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27893",
    "data-name": "Path 27893",
    d: "M159.827,191.234h0a6.786,6.786,0,0,0,6.785-6.785V141.506a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 385.502)",
    fill: "#fff"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27894",
    "data-name": "Path 27894",
    d: "M155.482,134.721h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V137.385a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 385.502)",
    fill: "#bec4fa"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27895",
    "data-name": "Path 27895",
    d: "M166.11,210.539h0a6.786,6.786,0,0,0,6.785-6.785v-42.94a6.785,6.785,0,1,0-13.569,0v42.94a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(455.906 440.743)",
    fill: "#fff"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27896",
    "data-name": "Path 27896",
    d: "M161.766,154.027h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.441-2.664V156.691a2.56,2.56,0,0,1,2.441-2.664",
    transform: "translate(455.906 440.746)",
    fill: "#bec4fa"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27897",
    "data-name": "Path 27897",
    d: "M191.062,174.8c0-.046.012-.093.012-.139V172.4a2.561,2.561,0,0,0-2.44-2.668h-33.22a2.561,2.561,0,0,0-2.44,2.668v2.259c0,.046.012.093.012.139Z",
    transform: "translate(437.727 485.677)",
    fill: "#fff"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27898",
    "data-name": "Path 27898",
    d: "M154.613,174.8c0-.046-.012-.093-.012-.139V172.4a2.561,2.561,0,0,1,2.44-2.668h-1.63a2.561,2.561,0,0,0-2.44,2.668v2.259c0,.046.012.093.012.139Z",
    transform: "translate(437.727 485.677)",
    fill: "#bec4fa"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27899",
    "data-name": "Path 27899",
    d: "M159.827,210.539h0a6.786,6.786,0,0,0,6.785-6.785v-42.94a6.785,6.785,0,1,0-13.569,0v42.94a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 440.743)",
    fill: "#e5e7f2"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27900",
    "data-name": "Path 27900",
    d: "M155.482,154.027h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V156.691a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 440.746)",
    fill: "#f8f9fd"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27901",
    "data-name": "Path 27901",
    d: "M159.827,210.539h0a6.786,6.786,0,0,0,6.785-6.785v-42.94a6.785,6.785,0,1,0-13.569,0v42.94a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(437.928 440.743)",
    fill: "#fff"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27902",
    "data-name": "Path 27902",
    d: "M155.482,154.027h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V156.691a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(437.928 440.746)",
    fill: "#bec4fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10261",
    "data-name": "Group 10261",
    transform: "translate(570.222 364.311)",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10260",
    "data-name": "Group 10260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10259",
    "data-name": "Group 10259",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27903",
    "data-name": "Path 27903",
    d: "M199.722,390.506V94.345H149.692a2.107,2.107,0,0,0-2.023,2.186V390.506Z",
    transform: "translate(-147.669 -94.344)",
    fill: "#bec4fa"
  }))))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27904",
    "data-name": "Path 27904",
    d: "M251.955,453.181V74.84a2.316,2.316,0,0,0-2.224-2.4H113.544a2.316,2.316,0,0,0-2.224,2.4V453.181Z",
    transform: "translate(318.541 207.292)",
    fill: "#eff1fd"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27905",
    "data-name": "Path 27905",
    d: "M240.163,453.181V74.84a2.316,2.316,0,0,0-2.224-2.4H131.029a2.316,2.316,0,0,0-2.224,2.4V453.181Z",
    transform: "translate(368.574 207.292)",
    fill: "#bec4fa"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27906",
    "data-name": "Path 27906",
    d: "M209.852,84H135.909a2.809,2.809,0,0,1-2.68-2.927V78.591a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927V81.07A2.811,2.811,0,0,1,209.852,84",
    transform: "translate(381.233 216.512)",
    fill: "#e5e7f2"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27907",
    "data-name": "Path 27907",
    d: "M154.4,75.664h-1.788a2.811,2.811,0,0,1,2.68,2.927V81.07A2.811,2.811,0,0,1,152.609,84H154.4a2.811,2.811,0,0,0,2.68-2.927V78.591a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 216.512)",
    fill: "#f8f9fd"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27908",
    "data-name": "Path 27908",
    d: "M209.852,88.622H135.909a2.809,2.809,0,0,1-2.68-2.927V83.216a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927V85.7a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 229.746)",
    fill: "#e5e7f2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27909",
    "data-name": "Path 27909",
    d: "M154.4,80.289h-1.788a2.811,2.811,0,0,1,2.68,2.927V85.7a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927V83.216a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 229.746)",
    fill: "#f8f9fd"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27910",
    "data-name": "Path 27910",
    d: "M209.852,88.622H135.909a2.809,2.809,0,0,1-2.68-2.927V83.216a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927V85.7a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 229.746)",
    fill: "#e5e7f2"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27911",
    "data-name": "Path 27911",
    d: "M154.4,80.289h-1.788a2.811,2.811,0,0,1,2.68,2.927V85.7a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927V83.216a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 229.746)",
    fill: "#f8f9fd"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27912",
    "data-name": "Path 27912",
    d: "M209.852,93.248H135.909a2.809,2.809,0,0,1-2.68-2.927V87.842a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 242.983)",
    fill: "#e5e7f2"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27913",
    "data-name": "Path 27913",
    d: "M154.4,84.915h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927V87.842a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 242.983)",
    fill: "#f8f9fd"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27914",
    "data-name": "Path 27914",
    d: "M209.852,97.873H135.909a2.809,2.809,0,0,1-2.68-2.927V92.467a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 256.218)",
    fill: "#e5e7f2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27915",
    "data-name": "Path 27915",
    d: "M154.4,89.54h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927V92.467a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 256.218)",
    fill: "#f8f9fd"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27916",
    "data-name": "Path 27916",
    d: "M209.852,102.5H135.909a2.809,2.809,0,0,1-2.68-2.927V97.092a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 269.452)",
    fill: "#e5e7f2"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27917",
    "data-name": "Path 27917",
    d: "M154.4,94.166h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927V97.093a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 269.455)",
    fill: "#f8f9fd"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27918",
    "data-name": "Path 27918",
    d: "M209.852,107.124H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927V104.2a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 282.689)",
    fill: "#e5e7f2"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27919",
    "data-name": "Path 27919",
    d: "M154.4,98.791h-1.788a2.811,2.811,0,0,1,2.68,2.927V104.2a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 282.689)",
    fill: "#f8f9fd"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27920",
    "data-name": "Path 27920",
    d: "M209.852,111.749H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 295.924)",
    fill: "#e5e7f2"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27921",
    "data-name": "Path 27921",
    d: "M154.4,103.416h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 295.924)",
    fill: "#f8f9fd"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27922",
    "data-name": "Path 27922",
    d: "M209.852,116.374H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 309.158)",
    fill: "#e5e7f2"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27923",
    "data-name": "Path 27923",
    d: "M154.4,108.042h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 309.161)",
    fill: "#f8f9fd"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27924",
    "data-name": "Path 27924",
    d: "M209.852,121H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.812,2.812,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 322.395)",
    fill: "#e5e7f2"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27925",
    "data-name": "Path 27925",
    d: "M154.4,112.667h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.812,2.812,0,0,0-2.68-2.927",
    transform: "translate(436.689 322.395)",
    fill: "#f8f9fd"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27926",
    "data-name": "Path 27926",
    d: "M209.852,125.625H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927V122.7a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 335.63)",
    fill: "#e5e7f2"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27927",
    "data-name": "Path 27927",
    d: "M154.4,117.292h-1.788a2.811,2.811,0,0,1,2.68,2.927V122.7a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 335.63)",
    fill: "#f8f9fd"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27928",
    "data-name": "Path 27928",
    d: "M209.852,130.251H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.812,2.812,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 348.867)",
    fill: "#e5e7f2"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27929",
    "data-name": "Path 27929",
    d: "M154.4,121.918h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.812,2.812,0,0,0-2.68-2.927",
    transform: "translate(436.689 348.867)",
    fill: "#f8f9fd"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27930",
    "data-name": "Path 27930",
    d: "M209.852,134.876H135.909a2.809,2.809,0,0,1-2.68-2.927V129.47a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.812,2.812,0,0,1-2.68,2.927",
    transform: "translate(381.233 362.101)",
    fill: "#e5e7f2"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27931",
    "data-name": "Path 27931",
    d: "M154.4,126.543h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.812,2.812,0,0,0,2.68-2.927V129.47a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 362.101)",
    fill: "#f8f9fd"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27932",
    "data-name": "Path 27932",
    d: "M209.852,139.5H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 375.336)",
    fill: "#e5e7f2"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27933",
    "data-name": "Path 27933",
    d: "M154.4,131.168h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 375.336)",
    fill: "#f8f9fd"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27934",
    "data-name": "Path 27934",
    d: "M209.852,144.127H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927V141.2a2.812,2.812,0,0,1-2.68,2.927",
    transform: "translate(381.233 388.573)",
    fill: "#e5e7f2"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27935",
    "data-name": "Path 27935",
    d: "M154.4,135.794h-1.788a2.811,2.811,0,0,1,2.68,2.927V141.2a2.811,2.811,0,0,1-2.68,2.927H154.4a2.812,2.812,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 388.573)",
    fill: "#f8f9fd"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27936",
    "data-name": "Path 27936",
    d: "M209.852,148.752H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 401.807)",
    fill: "#e5e7f2"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27937",
    "data-name": "Path 27937",
    d: "M154.4,140.419h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 401.807)",
    fill: "#f8f9fd"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27938",
    "data-name": "Path 27938",
    d: "M209.852,153.377H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 415.042)",
    fill: "#e5e7f2"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27939",
    "data-name": "Path 27939",
    d: "M154.4,145.045h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 415.044)",
    fill: "#f8f9fd"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27940",
    "data-name": "Path 27940",
    d: "M209.852,158H135.909a2.809,2.809,0,0,1-2.68-2.927V152.6a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 428.279)",
    fill: "#e5e7f2"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27941",
    "data-name": "Path 27941",
    d: "M154.4,149.67h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927V152.6a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 428.279)",
    fill: "#f8f9fd"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27942",
    "data-name": "Path 27942",
    d: "M209.852,162.628H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927V159.7a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 441.513)",
    fill: "#e5e7f2"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27943",
    "data-name": "Path 27943",
    d: "M154.4,154.295h-1.788a2.811,2.811,0,0,1,2.68,2.927V159.7a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 441.513)",
    fill: "#f8f9fd"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27944",
    "data-name": "Path 27944",
    d: "M209.852,167.253H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.812,2.812,0,0,1,2.68,2.927v2.479a2.812,2.812,0,0,1-2.68,2.927",
    transform: "translate(381.233 454.748)",
    fill: "#e5e7f2"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27945",
    "data-name": "Path 27945",
    d: "M154.4,158.921h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 454.75)",
    fill: "#f8f9fd"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27946",
    "data-name": "Path 27946",
    d: "M209.852,171.879H135.909a2.809,2.809,0,0,1-2.68-2.927v-2.479a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 467.985)",
    fill: "#e5e7f2"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27947",
    "data-name": "Path 27947",
    d: "M154.4,163.546h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 467.985)",
    fill: "#f8f9fd"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27948",
    "data-name": "Path 27948",
    d: "M209.852,176.5H135.909a2.809,2.809,0,0,1-2.68-2.927V171.1a2.809,2.809,0,0,1,2.68-2.927h73.944a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927",
    transform: "translate(381.233 481.219)",
    fill: "#e5e7f2"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27949",
    "data-name": "Path 27949",
    d: "M154.4,168.171h-1.788a2.811,2.811,0,0,1,2.68,2.927v2.479a2.811,2.811,0,0,1-2.68,2.927H154.4a2.811,2.811,0,0,0,2.68-2.927V171.1a2.811,2.811,0,0,0-2.68-2.927",
    transform: "translate(436.689 481.219)",
    fill: "#f8f9fd"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27950",
    "data-name": "Path 27950",
    d: "M116.521,84h44.67a2.811,2.811,0,0,0,2.68-2.927V78.591a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927V81.07A2.811,2.811,0,0,0,116.521,84",
    transform: "translate(325.755 216.512)",
    fill: "#fff"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27951",
    "data-name": "Path 27951",
    d: "M116.521,75.664h1.788a2.811,2.811,0,0,0-2.68,2.927V81.07A2.811,2.811,0,0,0,118.309,84h-1.788a2.811,2.811,0,0,1-2.68-2.927V78.591a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 216.512)",
    fill: "#bec4fa"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27952",
    "data-name": "Path 27952",
    d: "M116.521,88.622h44.67a2.811,2.811,0,0,0,2.68-2.927V83.216a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927V85.7a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 229.746)",
    fill: "#fff"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27953",
    "data-name": "Path 27953",
    d: "M116.521,80.289h1.788a2.811,2.811,0,0,0-2.68,2.927V85.7a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927V83.216a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 229.746)",
    fill: "#bec4fa"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27954",
    "data-name": "Path 27954",
    d: "M116.521,88.622h44.67a2.811,2.811,0,0,0,2.68-2.927V83.216a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927V85.7a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 229.746)",
    fill: "#fff"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27955",
    "data-name": "Path 27955",
    d: "M116.521,80.289h1.788a2.811,2.811,0,0,0-2.68,2.927V85.7a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927V83.216a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 229.746)",
    fill: "#bec4fa"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27956",
    "data-name": "Path 27956",
    d: "M116.521,93.248h44.67a2.811,2.811,0,0,0,2.68-2.927V87.842a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 242.983)",
    fill: "#fff"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27957",
    "data-name": "Path 27957",
    d: "M116.521,84.915h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927V87.842a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 242.983)",
    fill: "#bec4fa"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27958",
    "data-name": "Path 27958",
    d: "M116.521,97.873h44.67a2.811,2.811,0,0,0,2.68-2.927V92.467a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 256.218)",
    fill: "#fff"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27959",
    "data-name": "Path 27959",
    d: "M116.521,89.54h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927V92.467a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 256.218)",
    fill: "#bec4fa"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27960",
    "data-name": "Path 27960",
    d: "M116.521,102.5h44.67a2.811,2.811,0,0,0,2.68-2.927V97.092a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 269.452)",
    fill: "#fff"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27961",
    "data-name": "Path 27961",
    d: "M116.521,94.166h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927V97.093a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 269.455)",
    fill: "#bec4fa"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27962",
    "data-name": "Path 27962",
    d: "M116.521,107.124h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927V104.2a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 282.689)",
    fill: "#fff"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27963",
    "data-name": "Path 27963",
    d: "M116.521,98.791h1.788a2.811,2.811,0,0,0-2.68,2.927V104.2a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 282.689)",
    fill: "#bec4fa"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27964",
    "data-name": "Path 27964",
    d: "M116.521,111.749h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 295.924)",
    fill: "#fff"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27965",
    "data-name": "Path 27965",
    d: "M116.521,103.416h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 295.924)",
    fill: "#bec4fa"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27966",
    "data-name": "Path 27966",
    d: "M116.521,116.374h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 309.158)",
    fill: "#fff"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27967",
    "data-name": "Path 27967",
    d: "M116.521,108.042h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 309.161)",
    fill: "#bec4fa"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27968",
    "data-name": "Path 27968",
    d: "M116.521,121h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 322.395)",
    fill: "#fff"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27969",
    "data-name": "Path 27969",
    d: "M116.521,112.667h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 322.395)",
    fill: "#bec4fa"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27970",
    "data-name": "Path 27970",
    d: "M116.521,125.625h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927V122.7a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 335.63)",
    fill: "#fff"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27971",
    "data-name": "Path 27971",
    d: "M116.521,117.292h1.788a2.811,2.811,0,0,0-2.68,2.927V122.7a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 335.63)",
    fill: "#bec4fa"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27972",
    "data-name": "Path 27972",
    d: "M116.521,130.251h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 348.867)",
    fill: "#fff"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27973",
    "data-name": "Path 27973",
    d: "M116.521,121.918h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 348.867)",
    fill: "#bec4fa"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27974",
    "data-name": "Path 27974",
    d: "M116.521,134.876h44.67a2.811,2.811,0,0,0,2.68-2.927V129.47a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 362.101)",
    fill: "#fff"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27975",
    "data-name": "Path 27975",
    d: "M116.521,126.543h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927V129.47a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 362.101)",
    fill: "#bec4fa"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27976",
    "data-name": "Path 27976",
    d: "M116.521,139.5h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 375.336)",
    fill: "#fff"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27977",
    "data-name": "Path 27977",
    d: "M116.521,131.168h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 375.336)",
    fill: "#bec4fa"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27978",
    "data-name": "Path 27978",
    d: "M116.521,144.127h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927V141.2a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 388.573)",
    fill: "#fff"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27979",
    "data-name": "Path 27979",
    d: "M116.521,135.794h1.788a2.811,2.811,0,0,0-2.68,2.927V141.2a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 388.573)",
    fill: "#bec4fa"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27980",
    "data-name": "Path 27980",
    d: "M116.521,148.752h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 401.807)",
    fill: "#fff"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27981",
    "data-name": "Path 27981",
    d: "M116.521,140.419h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 401.807)",
    fill: "#bec4fa"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27982",
    "data-name": "Path 27982",
    d: "M116.521,153.377h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 415.042)",
    fill: "#fff"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27983",
    "data-name": "Path 27983",
    d: "M116.521,145.045h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 415.044)",
    fill: "#bec4fa"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27984",
    "data-name": "Path 27984",
    d: "M116.521,158h44.67a2.811,2.811,0,0,0,2.68-2.927V152.6a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 428.279)",
    fill: "#fff"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27985",
    "data-name": "Path 27985",
    d: "M116.521,149.67h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927V152.6a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 428.279)",
    fill: "#bec4fa"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27986",
    "data-name": "Path 27986",
    d: "M116.521,162.628h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927V159.7a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 441.513)",
    fill: "#fff"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27987",
    "data-name": "Path 27987",
    d: "M116.521,154.295h1.788a2.811,2.811,0,0,0-2.68,2.927V159.7a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 441.513)",
    fill: "#bec4fa"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27988",
    "data-name": "Path 27988",
    d: "M116.521,167.253h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 454.748)",
    fill: "#fff"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27989",
    "data-name": "Path 27989",
    d: "M116.521,158.921h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 454.75)",
    fill: "#bec4fa"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27990",
    "data-name": "Path 27990",
    d: "M116.521,171.879h44.67a2.811,2.811,0,0,0,2.68-2.927v-2.479a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 467.985)",
    fill: "#fff"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27991",
    "data-name": "Path 27991",
    d: "M116.521,163.546h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927v-2.479a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 467.985)",
    fill: "#bec4fa"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27992",
    "data-name": "Path 27992",
    d: "M116.521,176.5h44.67a2.811,2.811,0,0,0,2.68-2.927V171.1a2.811,2.811,0,0,0-2.68-2.927h-44.67a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927",
    transform: "translate(325.755 481.219)",
    fill: "#fff"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27993",
    "data-name": "Path 27993",
    d: "M116.521,168.171h1.788a2.811,2.811,0,0,0-2.68,2.927v2.479a2.811,2.811,0,0,0,2.68,2.927h-1.788a2.811,2.811,0,0,1-2.68-2.927V171.1a2.811,2.811,0,0,1,2.68-2.927",
    transform: "translate(325.755 481.219)",
    fill: "#bec4fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10264",
    "data-name": "Group 10264",
    transform: "translate(429.861 279.734)",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10263",
    "data-name": "Group 10263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10262",
    "data-name": "Group 10262",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27994",
    "data-name": "Path 27994",
    d: "M164.941,453.181V72.442h-51.4a2.314,2.314,0,0,0-2.224,2.4V453.181Z",
    transform: "translate(-111.32 -72.442)",
    fill: "#bec4fa"
  }))))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27995",
    "data-name": "Path 27995",
    d: "M171.6,471.283V68.3a2.11,2.11,0,0,0-2.027-2.186H45.53A2.11,2.11,0,0,0,43.5,68.3V471.283Z",
    transform: "translate(124.483 189.19)",
    fill: "#eff1fd"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27996",
    "data-name": "Path 27996",
    d: "M160.863,471.283V68.3a2.11,2.11,0,0,0-2.027-2.186H61.456A2.11,2.11,0,0,0,59.429,68.3V471.283Z",
    transform: "translate(170.055 189.19)",
    fill: "#bec4fa"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27997",
    "data-name": "Path 27997",
    d: "M68.1,124.394h0a6.786,6.786,0,0,1-6.785-6.785V74.669a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(175.446 194.241)",
    fill: "#e5e7f2"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27998",
    "data-name": "Path 27998",
    d: "M65.4,67.882h-1.63a2.56,2.56,0,0,1,2.44,2.664V121.73a2.56,2.56,0,0,1-2.44,2.664H65.4a2.56,2.56,0,0,0,2.44-2.664V70.546a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(182.486 194.243)",
    fill: "#f8f9fd"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27999",
    "data-name": "Path 27999",
    d: "M143.621,91.176H65.109a3.8,3.8,0,0,1,0-7.592h78.512a3.8,3.8,0,0,1,0,7.592",
    transform: "translate(175.446 239.175)",
    fill: "#e5e7f2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28000",
    "data-name": "Path 28000",
    d: "M84.186,83.584h-1.63A2.56,2.56,0,0,1,85,86.248v2.259a2.561,2.561,0,0,1-2.44,2.668h1.63a2.561,2.561,0,0,0,2.44-2.668V86.248a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.233 239.175)",
    fill: "#f8f9fd"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28001",
    "data-name": "Path 28001",
    d: "M74.381,124.394h0a6.784,6.784,0,0,1-6.785-6.785V74.669a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 194.241)",
    fill: "#e5e7f2"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28002",
    "data-name": "Path 28002",
    d: "M71.686,67.882h-1.63a2.56,2.56,0,0,1,2.44,2.664V121.73a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V70.546a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 194.243)",
    fill: "#f8f9fd"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28003",
    "data-name": "Path 28003",
    d: "M74.381,124.394h0a6.784,6.784,0,0,1-6.785-6.785V74.669a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 194.241)",
    fill: "#e5e7f2"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28004",
    "data-name": "Path 28004",
    d: "M71.686,67.882h-1.63a2.56,2.56,0,0,1,2.44,2.664V121.73a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V70.546a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 194.243)",
    fill: "#f8f9fd"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28005",
    "data-name": "Path 28005",
    d: "M80.663,124.394h0a6.786,6.786,0,0,1-6.785-6.785V74.666a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(211.401 194.241)",
    fill: "#e5e7f2"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28006",
    "data-name": "Path 28006",
    d: "M77.969,67.882h-1.63a2.56,2.56,0,0,1,2.44,2.664V121.73a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V70.546a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(218.443 194.243)",
    fill: "#f8f9fd"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28007",
    "data-name": "Path 28007",
    d: "M86.946,124.394h0a6.786,6.786,0,0,1-6.785-6.785V74.669a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(229.38 194.241)",
    fill: "#e5e7f2"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28008",
    "data-name": "Path 28008",
    d: "M84.252,67.882h-1.63a2.56,2.56,0,0,1,2.44,2.664V121.73a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V70.546a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.422 194.243)",
    fill: "#f8f9fd"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28009",
    "data-name": "Path 28009",
    d: "M68.1,143.639h0a6.786,6.786,0,0,1-6.785-6.785V93.911a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(175.446 249.31)",
    fill: "#e5e7f2"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28010",
    "data-name": "Path 28010",
    d: "M65.4,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664H65.4a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(182.486 249.313)",
    fill: "#f8f9fd"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28011",
    "data-name": "Path 28011",
    d: "M143.621,110.421H65.109a3.8,3.8,0,1,1,0-7.592l78.512,0a3.794,3.794,0,0,1,0,7.588",
    transform: "translate(175.446 294.244)",
    fill: "#e5e7f2"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28012",
    "data-name": "Path 28012",
    d: "M84.186,102.83h-1.63A2.56,2.56,0,0,1,85,105.494v2.259a2.558,2.558,0,0,1-2.44,2.664h1.63a2.558,2.558,0,0,0,2.44-2.664v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.233 294.247)",
    fill: "#f8f9fd"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28013",
    "data-name": "Path 28013",
    d: "M74.381,143.639h0a6.786,6.786,0,0,1-6.785-6.785V93.911a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 249.31)",
    fill: "#e5e7f2"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28014",
    "data-name": "Path 28014",
    d: "M71.686,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 249.313)",
    fill: "#f8f9fd"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28015",
    "data-name": "Path 28015",
    d: "M74.381,143.639h0a6.786,6.786,0,0,1-6.785-6.785V93.911a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 249.31)",
    fill: "#e5e7f2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28016",
    "data-name": "Path 28016",
    d: "M71.686,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 249.313)",
    fill: "#f8f9fd"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28017",
    "data-name": "Path 28017",
    d: "M80.663,143.639h0a6.786,6.786,0,0,1-6.785-6.785V93.911a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(211.401 249.31)",
    fill: "#e5e7f2"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28018",
    "data-name": "Path 28018",
    d: "M77.969,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(218.443 249.313)",
    fill: "#f8f9fd"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28019",
    "data-name": "Path 28019",
    d: "M86.949,143.639h0a6.787,6.787,0,0,1-6.788-6.785V93.915a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.781,6.785",
    transform: "translate(229.38 249.31)",
    fill: "#e5e7f2"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28020",
    "data-name": "Path 28020",
    d: "M84.252,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.422 249.313)",
    fill: "#f8f9fd"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28021",
    "data-name": "Path 28021",
    d: "M68.1,143.639h0a6.786,6.786,0,0,1-6.785-6.785V93.911a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(175.446 249.31)",
    fill: "#e5e7f2"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28022",
    "data-name": "Path 28022",
    d: "M65.4,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664H65.4a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(182.486 249.313)",
    fill: "#f8f9fd"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28023",
    "data-name": "Path 28023",
    d: "M143.621,110.421H65.109a3.8,3.8,0,1,1,0-7.592l78.512,0a3.794,3.794,0,0,1,0,7.588",
    transform: "translate(175.446 294.244)",
    fill: "#e5e7f2"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28024",
    "data-name": "Path 28024",
    d: "M84.186,102.83h-1.63A2.56,2.56,0,0,1,85,105.494v2.259a2.558,2.558,0,0,1-2.44,2.664h1.63a2.558,2.558,0,0,0,2.44-2.664v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.233 294.247)",
    fill: "#f8f9fd"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28025",
    "data-name": "Path 28025",
    d: "M74.381,143.639h0a6.786,6.786,0,0,1-6.785-6.785V93.911a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 249.31)",
    fill: "#e5e7f2"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28026",
    "data-name": "Path 28026",
    d: "M71.686,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 249.313)",
    fill: "#f8f9fd"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28027",
    "data-name": "Path 28027",
    d: "M74.381,143.639h0a6.786,6.786,0,0,1-6.785-6.785V93.911a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 249.31)",
    fill: "#e5e7f2"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28028",
    "data-name": "Path 28028",
    d: "M71.686,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 249.313)",
    fill: "#f8f9fd"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28029",
    "data-name": "Path 28029",
    d: "M80.663,143.639h0a6.786,6.786,0,0,1-6.785-6.785V93.911a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(211.401 249.31)",
    fill: "#e5e7f2"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28030",
    "data-name": "Path 28030",
    d: "M77.969,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(218.443 249.313)",
    fill: "#f8f9fd"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28031",
    "data-name": "Path 28031",
    d: "M86.949,143.639h0a6.787,6.787,0,0,1-6.788-6.785V93.915a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.781,6.785",
    transform: "translate(229.38 249.31)",
    fill: "#e5e7f2"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28032",
    "data-name": "Path 28032",
    d: "M84.252,87.127h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V89.791a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.422 249.313)",
    fill: "#f8f9fd"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28033",
    "data-name": "Path 28033",
    d: "M68.1,162.884h0a6.784,6.784,0,0,1-6.785-6.785V113.156a6.785,6.785,0,0,1,13.569,0V156.1a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(175.446 304.379)",
    fill: "#e5e7f2"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28034",
    "data-name": "Path 28034",
    d: "M65.4,106.372h-1.63a2.56,2.56,0,0,1,2.44,2.664V160.22a2.56,2.56,0,0,1-2.44,2.664H65.4a2.56,2.56,0,0,0,2.44-2.664V109.036a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(182.486 304.382)",
    fill: "#f8f9fd"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28035",
    "data-name": "Path 28035",
    d: "M143.621,129.666H65.109a3.8,3.8,0,0,1,0-7.592h78.512a3.8,3.8,0,0,1,0,7.592",
    transform: "translate(175.446 349.313)",
    fill: "#e5e7f2"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28036",
    "data-name": "Path 28036",
    d: "M84.186,122.075h-1.63A2.56,2.56,0,0,1,85,124.739V127a2.561,2.561,0,0,1-2.44,2.668h1.63A2.561,2.561,0,0,0,86.626,127v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.233 349.316)",
    fill: "#f8f9fd"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28037",
    "data-name": "Path 28037",
    d: "M74.381,162.884h0A6.786,6.786,0,0,1,67.6,156.1V113.156a6.785,6.785,0,1,1,13.569,0V156.1a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 304.379)",
    fill: "#e5e7f2"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28038",
    "data-name": "Path 28038",
    d: "M71.686,106.372h-1.63a2.56,2.56,0,0,1,2.44,2.664V160.22a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V109.036a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 304.382)",
    fill: "#f8f9fd"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28039",
    "data-name": "Path 28039",
    d: "M74.381,162.884h0A6.786,6.786,0,0,1,67.6,156.1V113.156a6.785,6.785,0,1,1,13.569,0V156.1a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 304.379)",
    fill: "#e5e7f2"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28040",
    "data-name": "Path 28040",
    d: "M71.686,106.372h-1.63a2.56,2.56,0,0,1,2.44,2.664V160.22a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V109.036a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 304.382)",
    fill: "#f8f9fd"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28041",
    "data-name": "Path 28041",
    d: "M80.663,162.884h0a6.786,6.786,0,0,1-6.785-6.785v-42.94a6.785,6.785,0,1,1,13.569,0V156.1a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(211.401 304.379)",
    fill: "#e5e7f2"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28042",
    "data-name": "Path 28042",
    d: "M77.969,106.372h-1.63a2.56,2.56,0,0,1,2.44,2.664V160.22a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V109.036a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(218.443 304.382)",
    fill: "#f8f9fd"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28043",
    "data-name": "Path 28043",
    d: "M86.946,162.884h0a6.786,6.786,0,0,1-6.785-6.785v-42.94a6.785,6.785,0,1,1,13.569,0V156.1a6.784,6.784,0,0,1-6.785,6.785",
    transform: "translate(229.38 304.379)",
    fill: "#e5e7f2"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28044",
    "data-name": "Path 28044",
    d: "M84.252,106.372h-1.63a2.56,2.56,0,0,1,2.44,2.664V160.22a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V109.036a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.422 304.382)",
    fill: "#f8f9fd"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28045",
    "data-name": "Path 28045",
    d: "M68.1,182.13h0a6.786,6.786,0,0,1-6.785-6.785v-42.94a6.785,6.785,0,1,1,13.569,0v42.94A6.786,6.786,0,0,1,68.1,182.13",
    transform: "translate(175.446 359.451)",
    fill: "#e5e7f2"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28046",
    "data-name": "Path 28046",
    d: "M65.4,125.617h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664H65.4a2.56,2.56,0,0,0,2.44-2.664V128.281a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(182.486 359.451)",
    fill: "#f8f9fd"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28047",
    "data-name": "Path 28047",
    d: "M143.621,148.911H65.109a3.8,3.8,0,0,1,0-7.592h78.512a3.8,3.8,0,0,1,0,7.592",
    transform: "translate(175.446 404.383)",
    fill: "#e5e7f2"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28048",
    "data-name": "Path 28048",
    d: "M84.186,141.32h-1.63A2.56,2.56,0,0,1,85,143.984v2.259a2.561,2.561,0,0,1-2.44,2.668h1.63a2.561,2.561,0,0,0,2.44-2.668v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.233 404.385)",
    fill: "#f8f9fd"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28049",
    "data-name": "Path 28049",
    d: "M74.381,182.13h0a6.786,6.786,0,0,1-6.785-6.785v-42.94a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 359.451)",
    fill: "#e5e7f2"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28050",
    "data-name": "Path 28050",
    d: "M71.686,125.617h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V128.281a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 359.451)",
    fill: "#f8f9fd"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28051",
    "data-name": "Path 28051",
    d: "M74.381,182.13h0a6.786,6.786,0,0,1-6.785-6.785v-42.94a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 359.451)",
    fill: "#e5e7f2"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28052",
    "data-name": "Path 28052",
    d: "M71.686,125.617h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V128.281a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 359.451)",
    fill: "#f8f9fd"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28053",
    "data-name": "Path 28053",
    d: "M80.664,182.13h0a6.784,6.784,0,0,1-6.785-6.785v-42.94a6.785,6.785,0,1,1,13.569,0v42.94a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(211.404 359.451)",
    fill: "#e5e7f2"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28054",
    "data-name": "Path 28054",
    d: "M77.969,125.617h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V128.281a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(218.443 359.451)",
    fill: "#f8f9fd"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28055",
    "data-name": "Path 28055",
    d: "M86.946,182.13h0a6.786,6.786,0,0,1-6.785-6.785V132.4a6.785,6.785,0,1,1,13.569,0v42.944a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(229.38 359.451)",
    fill: "#e5e7f2"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28056",
    "data-name": "Path 28056",
    d: "M84.252,125.617h-1.63a2.56,2.56,0,0,1,2.44,2.664v51.184a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V128.281a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.422 359.451)",
    fill: "#f8f9fd"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28057",
    "data-name": "Path 28057",
    d: "M68.1,201.375h0a6.786,6.786,0,0,1-6.785-6.785V151.647a6.785,6.785,0,0,1,13.569,0V194.59a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(175.446 414.521)",
    fill: "#e5e7f2"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28058",
    "data-name": "Path 28058",
    d: "M65.4,144.862h-1.63a2.56,2.56,0,0,1,2.44,2.664V198.71a2.56,2.56,0,0,1-2.44,2.664H65.4a2.56,2.56,0,0,0,2.44-2.664V147.526a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(182.486 414.521)",
    fill: "#f8f9fd"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28059",
    "data-name": "Path 28059",
    d: "M143.621,168.156H65.109a3.8,3.8,0,1,1,0-7.592h78.512a3.8,3.8,0,0,1,0,7.592",
    transform: "translate(175.446 459.452)",
    fill: "#e5e7f2"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28060",
    "data-name": "Path 28060",
    d: "M84.186,160.565h-1.63A2.56,2.56,0,0,1,85,163.229v2.259a2.561,2.561,0,0,1-2.44,2.668h1.63a2.561,2.561,0,0,0,2.44-2.668v-2.259a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.233 459.455)",
    fill: "#f8f9fd"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28061",
    "data-name": "Path 28061",
    d: "M74.381,201.375h0A6.786,6.786,0,0,1,67.6,194.59V151.647a6.785,6.785,0,0,1,13.569,0V194.59a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 414.521)",
    fill: "#e5e7f2"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28062",
    "data-name": "Path 28062",
    d: "M71.686,144.862h-1.63a2.56,2.56,0,0,1,2.44,2.664V198.71a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V147.526a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 414.521)",
    fill: "#f8f9fd"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28063",
    "data-name": "Path 28063",
    d: "M74.381,201.375h0A6.786,6.786,0,0,1,67.6,194.59V151.647a6.785,6.785,0,0,1,13.569,0V194.59a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(193.425 414.521)",
    fill: "#e5e7f2"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28064",
    "data-name": "Path 28064",
    d: "M71.686,144.862h-1.63a2.56,2.56,0,0,1,2.44,2.664V198.71a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V147.526a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(200.464 414.521)",
    fill: "#f8f9fd"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28065",
    "data-name": "Path 28065",
    d: "M80.663,201.375h0a6.786,6.786,0,0,1-6.785-6.785V151.647a6.785,6.785,0,0,1,13.569,0V194.59a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(211.401 414.521)",
    fill: "#e5e7f2"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28066",
    "data-name": "Path 28066",
    d: "M77.969,144.862h-1.63a2.56,2.56,0,0,1,2.44,2.664V198.71a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V147.526a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(218.443 414.521)",
    fill: "#f8f9fd"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28067",
    "data-name": "Path 28067",
    d: "M86.946,201.375h0a6.786,6.786,0,0,1-6.785-6.785V151.647a6.785,6.785,0,0,1,13.569,0V194.59a6.786,6.786,0,0,1-6.785,6.785",
    transform: "translate(229.38 414.521)",
    fill: "#e5e7f2"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28068",
    "data-name": "Path 28068",
    d: "M84.252,144.862h-1.63a2.56,2.56,0,0,1,2.44,2.664V198.71a2.56,2.56,0,0,1-2.44,2.664h1.63a2.56,2.56,0,0,0,2.44-2.664V147.526a2.56,2.56,0,0,0-2.44-2.664",
    transform: "translate(236.422 414.521)",
    fill: "#f8f9fd"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28069",
    "data-name": "Path 28069",
    d: "M59.332,124.394h0a6.786,6.786,0,0,0,6.785-6.785V74.669a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(150.363 194.241)",
    fill: "#fff"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28070",
    "data-name": "Path 28070",
    d: "M54.987,67.882h1.63a2.56,2.56,0,0,0-2.44,2.664V121.73a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V70.546a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(150.363 194.243)",
    fill: "#bec4fa"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28071",
    "data-name": "Path 28071",
    d: "M49.989,91.176H80.5a3.8,3.8,0,0,0,0-7.592H49.989a3.8,3.8,0,0,0,0,7.592",
    transform: "translate(132.181 239.175)",
    fill: "#fff"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28072",
    "data-name": "Path 28072",
    d: "M48.634,83.584h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.561,2.561,0,0,0,2.44,2.668h-1.63a2.561,2.561,0,0,1-2.44-2.668V86.248a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.184 239.175)",
    fill: "#bec4fa"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28073",
    "data-name": "Path 28073",
    d: "M53.049,124.394h0a6.786,6.786,0,0,0,6.785-6.785V74.669a6.785,6.785,0,1,0-13.569,0v42.94a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 194.241)",
    fill: "#e5e7f2"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28074",
    "data-name": "Path 28074",
    d: "M48.7,67.881h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V70.545a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.384 194.241)",
    fill: "#f8f9fd"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28075",
    "data-name": "Path 28075",
    d: "M53.049,124.394h0a6.786,6.786,0,0,0,6.785-6.785V74.669a6.785,6.785,0,1,0-13.569,0v42.94a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 194.241)",
    fill: "#fff"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28076",
    "data-name": "Path 28076",
    d: "M48.7,67.881h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V70.545a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.384 194.241)",
    fill: "#bec4fa"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28077",
    "data-name": "Path 28077",
    d: "M59.332,143.7h0a6.786,6.786,0,0,0,6.785-6.785V93.972a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(150.363 249.484)",
    fill: "#fff"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28078",
    "data-name": "Path 28078",
    d: "M54.987,87.187h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V89.851a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(150.363 249.484)",
    fill: "#bec4fa"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28079",
    "data-name": "Path 28079",
    d: "M49.99,110.481H80.5a3.8,3.8,0,1,0,0-7.592H49.99a3.8,3.8,0,0,0,0,7.592",
    transform: "translate(132.184 294.416)",
    fill: "#fff"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28080",
    "data-name": "Path 28080",
    d: "M48.634,102.89h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.561,2.561,0,0,0,2.44,2.668h-1.63a2.561,2.561,0,0,1-2.44-2.668v-2.259a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.184 294.418)",
    fill: "#bec4fa"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28081",
    "data-name": "Path 28081",
    d: "M53.049,143.7h0a6.786,6.786,0,0,0,6.785-6.785V93.976a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 249.484)",
    fill: "#e5e7f2"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28082",
    "data-name": "Path 28082",
    d: "M48.7,87.187h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V89.851a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.384 249.484)",
    fill: "#f8f9fd"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28083",
    "data-name": "Path 28083",
    d: "M53.049,143.7h0a6.786,6.786,0,0,0,6.785-6.785V93.976a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 249.484)",
    fill: "#fff"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28084",
    "data-name": "Path 28084",
    d: "M48.7,87.187h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V89.851a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.384 249.484)",
    fill: "#bec4fa"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28085",
    "data-name": "Path 28085",
    d: "M59.332,143.7h0a6.786,6.786,0,0,0,6.785-6.785V93.972a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(150.363 249.484)",
    fill: "#fff"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28086",
    "data-name": "Path 28086",
    d: "M54.987,87.187h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V89.851a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(150.363 249.484)",
    fill: "#bec4fa"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28087",
    "data-name": "Path 28087",
    d: "M49.99,110.481H80.5a3.8,3.8,0,1,0,0-7.592H49.99a3.8,3.8,0,0,0,0,7.592",
    transform: "translate(132.184 294.416)",
    fill: "#fff"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28088",
    "data-name": "Path 28088",
    d: "M48.634,102.89h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.561,2.561,0,0,0,2.44,2.668h-1.63a2.561,2.561,0,0,1-2.44-2.668v-2.259a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.184 294.418)",
    fill: "#bec4fa"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28089",
    "data-name": "Path 28089",
    d: "M53.049,143.7h0a6.786,6.786,0,0,0,6.785-6.785V93.976a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 249.484)",
    fill: "#e5e7f2"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28090",
    "data-name": "Path 28090",
    d: "M48.7,87.187h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V89.851a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.384 249.484)",
    fill: "#f8f9fd"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28091",
    "data-name": "Path 28091",
    d: "M53.049,143.7h0a6.786,6.786,0,0,0,6.785-6.785V93.976a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 249.484)",
    fill: "#fff"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28092",
    "data-name": "Path 28092",
    d: "M48.7,87.187h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V89.851a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.384 249.484)",
    fill: "#bec4fa"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28093",
    "data-name": "Path 28093",
    d: "M59.332,163h0a6.786,6.786,0,0,0,6.785-6.785v-42.94a6.785,6.785,0,1,0-13.569,0v42.94A6.786,6.786,0,0,0,59.332,163",
    transform: "translate(150.363 304.725)",
    fill: "#fff"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28094",
    "data-name": "Path 28094",
    d: "M54.987,106.492h1.63a2.56,2.56,0,0,0-2.44,2.664V160.34A2.56,2.56,0,0,0,56.617,163h-1.63a2.56,2.56,0,0,1-2.44-2.664V109.156a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(150.363 304.725)",
    fill: "#bec4fa"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28095",
    "data-name": "Path 28095",
    d: "M49.99,129.787H80.5a3.8,3.8,0,1,0,0-7.592H49.99a3.8,3.8,0,0,0,0,7.592",
    transform: "translate(132.184 349.659)",
    fill: "#fff"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28096",
    "data-name": "Path 28096",
    d: "M48.634,122.2h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.561,2.561,0,0,0,2.44,2.668h-1.63a2.561,2.561,0,0,1-2.44-2.668v-2.259a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.184 349.659)",
    fill: "#bec4fa"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28097",
    "data-name": "Path 28097",
    d: "M53.049,163h0a6.786,6.786,0,0,0,6.785-6.785v-42.94a6.785,6.785,0,1,0-13.569,0v42.94A6.786,6.786,0,0,0,53.049,163",
    transform: "translate(132.384 304.725)",
    fill: "#e5e7f2"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28098",
    "data-name": "Path 28098",
    d: "M48.7,106.492h1.63a2.56,2.56,0,0,0-2.44,2.664V160.34A2.56,2.56,0,0,0,50.334,163H48.7a2.56,2.56,0,0,1-2.44-2.664V109.156a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.384 304.725)",
    fill: "#f8f9fd"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28099",
    "data-name": "Path 28099",
    d: "M53.049,163h0a6.786,6.786,0,0,0,6.785-6.785v-42.94a6.785,6.785,0,1,0-13.569,0v42.94A6.786,6.786,0,0,0,53.049,163",
    transform: "translate(132.384 304.725)",
    fill: "#fff"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28100",
    "data-name": "Path 28100",
    d: "M48.7,106.492h1.63a2.56,2.56,0,0,0-2.44,2.664V160.34A2.56,2.56,0,0,0,50.334,163H48.7a2.56,2.56,0,0,1-2.44-2.664V109.156a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.384 304.725)",
    fill: "#bec4fa"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28101",
    "data-name": "Path 28101",
    d: "M59.332,182.31h0a6.786,6.786,0,0,0,6.785-6.785V132.582a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(150.363 359.967)",
    fill: "#fff"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28102",
    "data-name": "Path 28102",
    d: "M54.987,125.8h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V128.462a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(150.363 359.969)",
    fill: "#bec4fa"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28103",
    "data-name": "Path 28103",
    d: "M49.99,149.092H80.5a3.8,3.8,0,0,0,0-7.592H49.99a3.8,3.8,0,0,0,0,7.592",
    transform: "translate(132.184 404.9)",
    fill: "#fff"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28104",
    "data-name": "Path 28104",
    d: "M48.634,141.5h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.561,2.561,0,0,0,2.44,2.668h-1.63a2.561,2.561,0,0,1-2.44-2.668v-2.259a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.184 404.903)",
    fill: "#bec4fa"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28105",
    "data-name": "Path 28105",
    d: "M53.049,182.31h0a6.786,6.786,0,0,0,6.785-6.785V132.582a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 359.967)",
    fill: "#e5e7f2"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28106",
    "data-name": "Path 28106",
    d: "M48.7,125.8h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V128.462A2.56,2.56,0,0,1,48.7,125.8",
    transform: "translate(132.384 359.969)",
    fill: "#f8f9fd"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28107",
    "data-name": "Path 28107",
    d: "M53.049,182.31h0a6.786,6.786,0,0,0,6.785-6.785V132.582a6.785,6.785,0,1,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 359.967)",
    fill: "#fff"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28108",
    "data-name": "Path 28108",
    d: "M48.7,125.8h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V128.462A2.56,2.56,0,0,1,48.7,125.8",
    transform: "translate(132.384 359.969)",
    fill: "#bec4fa"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28109",
    "data-name": "Path 28109",
    d: "M59.332,201.616h0a6.784,6.784,0,0,0,6.785-6.785V151.888a6.785,6.785,0,0,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(150.363 415.21)",
    fill: "#fff"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28110",
    "data-name": "Path 28110",
    d: "M54.987,145.1h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664h-1.63a2.56,2.56,0,0,1-2.44-2.664V147.767a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(150.363 415.21)",
    fill: "#bec4fa"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28111",
    "data-name": "Path 28111",
    d: "M49.99,168.4H80.5a3.8,3.8,0,0,0,0-7.592H49.99a3.8,3.8,0,0,0,0,7.592",
    transform: "translate(132.184 460.144)",
    fill: "#fff"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28112",
    "data-name": "Path 28112",
    d: "M48.634,160.806h1.63a2.56,2.56,0,0,0-2.44,2.664v2.259a2.561,2.561,0,0,0,2.44,2.668h-1.63a2.561,2.561,0,0,1-2.44-2.668V163.47a2.56,2.56,0,0,1,2.44-2.664",
    transform: "translate(132.184 460.144)",
    fill: "#bec4fa"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28113",
    "data-name": "Path 28113",
    d: "M53.049,201.616h0a6.786,6.786,0,0,0,6.785-6.785V151.888a6.785,6.785,0,0,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 415.21)",
    fill: "#e5e7f2"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28114",
    "data-name": "Path 28114",
    d: "M48.7,145.1h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V147.767A2.56,2.56,0,0,1,48.7,145.1",
    transform: "translate(132.384 415.21)",
    fill: "#f8f9fd"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28115",
    "data-name": "Path 28115",
    d: "M53.049,201.616h0a6.786,6.786,0,0,0,6.785-6.785V151.888a6.785,6.785,0,0,0-13.569,0v42.944a6.786,6.786,0,0,0,6.785,6.785",
    transform: "translate(132.384 415.21)",
    fill: "#fff"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28116",
    "data-name": "Path 28116",
    d: "M48.7,145.1h1.63a2.56,2.56,0,0,0-2.44,2.664v51.184a2.56,2.56,0,0,0,2.44,2.664H48.7a2.56,2.56,0,0,1-2.44-2.664V147.767A2.56,2.56,0,0,1,48.7,145.1",
    transform: "translate(132.384 415.21)",
    fill: "#bec4fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10267",
    "data-name": "Group 10267",
    transform: "translate(256.352 255.306)",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10266",
    "data-name": "Group 10266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10265",
    "data-name": "Group 10265",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28117",
    "data-name": "Path 28117",
    d: "M140.952,471.283V68.3a2.11,2.11,0,0,0-2.027-2.186H66.387V471.283Z",
    transform: "translate(-66.386 -66.116)",
    fill: "#bec4fa"
  }))))), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28118",
    "data-name": "Path 28118",
    d: "M196.95,98.907H74.155v-59.5a8.819,8.819,0,0,1,8.82-8.82h105.16a8.818,8.818,0,0,1,8.816,8.82Z",
    transform: "translate(212.194 87.521)",
    fill: "#eff1fd"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28119",
    "data-name": "Path 28119",
    d: "M183.8,98.907H93.655v-59.5a8.818,8.818,0,0,1,8.816-8.82h72.511a8.819,8.819,0,0,1,8.82,8.82Z",
    transform: "translate(267.993 87.521)",
    fill: "#bec4fa"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28120",
    "data-name": "Path 28120",
    d: "M226.585,547.312V42.789a2.584,2.584,0,0,0-2.479-2.676H72.226a2.581,2.581,0,0,0-2.479,2.676V547.312Z",
    transform: "translate(199.58 114.783)",
    fill: "#eff1fd"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28121",
    "data-name": "Path 28121",
    d: "M213.436,547.312V42.789a2.584,2.584,0,0,0-2.479-2.676H91.726a2.581,2.581,0,0,0-2.479,2.676V547.312Z",
    transform: "translate(255.379 114.783)",
    fill: "#bec4fa"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28122",
    "data-name": "Path 28122",
    d: "M99.859,65.116h0a8.306,8.306,0,0,1-8.306-8.306V50.581a8.306,8.306,0,0,1,16.612,0V56.81a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 120.969)",
    fill: "#e5e7f2"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28123",
    "data-name": "Path 28123",
    d: "M96.559,42.275H94.566a3.132,3.132,0,0,1,2.985,3.263V61.853a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V45.538a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 120.969)",
    fill: "#f8f9fd"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28124",
    "data-name": "Path 28124",
    d: "M107.551,65.116h0a8.306,8.306,0,0,1-8.306-8.306V50.581a8.306,8.306,0,1,1,16.612,0V56.81a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 120.969)",
    fill: "#e5e7f2"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28125",
    "data-name": "Path 28125",
    d: "M104.251,42.275h-1.993a3.132,3.132,0,0,1,2.985,3.263V61.853a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V45.538a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 120.969)",
    fill: "#f8f9fd"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28126",
    "data-name": "Path 28126",
    d: "M107.551,65.116h0a8.306,8.306,0,0,1-8.306-8.306V50.581a8.306,8.306,0,1,1,16.612,0V56.81a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 120.969)",
    fill: "#e5e7f2"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28127",
    "data-name": "Path 28127",
    d: "M104.251,42.275h-1.993a3.132,3.132,0,0,1,2.985,3.263V61.853a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V45.538a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 120.969)",
    fill: "#f8f9fd"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28128",
    "data-name": "Path 28128",
    d: "M115.244,65.116h0a8.306,8.306,0,0,1-8.306-8.306V50.581a8.306,8.306,0,1,1,16.612,0V56.81a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 120.969)",
    fill: "#e5e7f2"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28129",
    "data-name": "Path 28129",
    d: "M111.943,42.275H109.95a3.132,3.132,0,0,1,2.985,3.263V61.853a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V45.538a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 120.969)",
    fill: "#f8f9fd"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28130",
    "data-name": "Path 28130",
    d: "M122.936,65.116h0a8.306,8.306,0,0,1-8.306-8.306V50.581a8.306,8.306,0,1,1,16.612,0V56.81a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 120.969)",
    fill: "#e5e7f2"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28131",
    "data-name": "Path 28131",
    d: "M119.636,42.275h-1.993a3.132,3.132,0,0,1,2.985,3.263V61.853a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V45.538a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 120.969)",
    fill: "#f8f9fd"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28132",
    "data-name": "Path 28132",
    d: "M99.859,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 154.847)",
    fill: "#e5e7f2"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28133",
    "data-name": "Path 28133",
    d: "M96.559,54.114H94.566a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 154.847)",
    fill: "#f8f9fd"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28134",
    "data-name": "Path 28134",
    d: "M107.551,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 154.847)",
    fill: "#e5e7f2"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28135",
    "data-name": "Path 28135",
    d: "M104.251,54.114h-1.993a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 154.847)",
    fill: "#f8f9fd"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28136",
    "data-name": "Path 28136",
    d: "M107.551,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 154.847)",
    fill: "#e5e7f2"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28137",
    "data-name": "Path 28137",
    d: "M104.251,54.114h-1.993a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 154.847)",
    fill: "#f8f9fd"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28138",
    "data-name": "Path 28138",
    d: "M115.244,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 154.847)",
    fill: "#e5e7f2"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28139",
    "data-name": "Path 28139",
    d: "M111.943,54.114H109.95a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 154.847)",
    fill: "#f8f9fd"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28140",
    "data-name": "Path 28140",
    d: "M122.936,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 154.847)",
    fill: "#e5e7f2"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28141",
    "data-name": "Path 28141",
    d: "M119.636,54.114h-1.993a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 154.847)",
    fill: "#f8f9fd"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28142",
    "data-name": "Path 28142",
    d: "M99.859,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 154.847)",
    fill: "#e5e7f2"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28143",
    "data-name": "Path 28143",
    d: "M96.559,54.114H94.566a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 154.847)",
    fill: "#f8f9fd"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28144",
    "data-name": "Path 28144",
    d: "M107.551,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 154.847)",
    fill: "#e5e7f2"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28145",
    "data-name": "Path 28145",
    d: "M104.251,54.114h-1.993a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 154.847)",
    fill: "#f8f9fd"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28146",
    "data-name": "Path 28146",
    d: "M107.551,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 154.847)",
    fill: "#e5e7f2"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28147",
    "data-name": "Path 28147",
    d: "M104.251,54.114h-1.993a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 154.847)",
    fill: "#f8f9fd"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28148",
    "data-name": "Path 28148",
    d: "M115.244,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 154.847)",
    fill: "#e5e7f2"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28149",
    "data-name": "Path 28149",
    d: "M111.943,54.114H109.95a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 154.847)",
    fill: "#f8f9fd"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28150",
    "data-name": "Path 28150",
    d: "M122.936,76.955h0a8.306,8.306,0,0,1-8.306-8.306V62.42a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 154.847)",
    fill: "#e5e7f2"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28151",
    "data-name": "Path 28151",
    d: "M119.636,54.114h-1.993a3.132,3.132,0,0,1,2.985,3.263V73.692a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V57.377a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 154.847)",
    fill: "#f8f9fd"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28152",
    "data-name": "Path 28152",
    d: "M99.859,88.794h0a8.306,8.306,0,0,1-8.306-8.306V74.259a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 188.724)",
    fill: "#e5e7f2"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28153",
    "data-name": "Path 28153",
    d: "M96.559,65.953H94.566a3.132,3.132,0,0,1,2.985,3.263V85.531a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V69.216a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 188.724)",
    fill: "#f8f9fd"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28154",
    "data-name": "Path 28154",
    d: "M107.551,88.794h0a8.306,8.306,0,0,1-8.306-8.306V74.259a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 188.724)",
    fill: "#e5e7f2"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28155",
    "data-name": "Path 28155",
    d: "M104.251,65.953h-1.993a3.132,3.132,0,0,1,2.985,3.263V85.531a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V69.216a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 188.724)",
    fill: "#f8f9fd"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28156",
    "data-name": "Path 28156",
    d: "M107.551,88.794h0a8.306,8.306,0,0,1-8.306-8.306V74.259a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 188.724)",
    fill: "#e5e7f2"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28157",
    "data-name": "Path 28157",
    d: "M104.251,65.953h-1.993a3.132,3.132,0,0,1,2.985,3.263V85.531a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V69.216a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 188.724)",
    fill: "#f8f9fd"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28158",
    "data-name": "Path 28158",
    d: "M115.244,88.794h0a8.306,8.306,0,0,1-8.306-8.306V74.259a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 188.724)",
    fill: "#e5e7f2"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28159",
    "data-name": "Path 28159",
    d: "M111.943,65.953H109.95a3.132,3.132,0,0,1,2.985,3.263V85.531a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V69.216a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 188.724)",
    fill: "#f8f9fd"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28160",
    "data-name": "Path 28160",
    d: "M122.936,88.794h0a8.306,8.306,0,0,1-8.306-8.306V74.259a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 188.724)",
    fill: "#e5e7f2"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28161",
    "data-name": "Path 28161",
    d: "M119.636,65.953h-1.993a3.132,3.132,0,0,1,2.985,3.263V85.531a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V69.216a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 188.724)",
    fill: "#f8f9fd"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28162",
    "data-name": "Path 28162",
    d: "M99.859,100.633h0a8.306,8.306,0,0,1-8.306-8.306V86.1a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 222.601)",
    fill: "#e5e7f2"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28163",
    "data-name": "Path 28163",
    d: "M96.559,77.792H94.566a3.132,3.132,0,0,1,2.985,3.263V97.37a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V81.055a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 222.601)",
    fill: "#f8f9fd"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28164",
    "data-name": "Path 28164",
    d: "M107.551,100.633h0a8.306,8.306,0,0,1-8.306-8.306V86.1a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 222.601)",
    fill: "#e5e7f2"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28165",
    "data-name": "Path 28165",
    d: "M104.251,77.792h-1.993a3.132,3.132,0,0,1,2.985,3.263V97.37a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V81.055a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 222.601)",
    fill: "#f8f9fd"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28166",
    "data-name": "Path 28166",
    d: "M107.551,100.633h0a8.306,8.306,0,0,1-8.306-8.306V86.1a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 222.601)",
    fill: "#e5e7f2"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28167",
    "data-name": "Path 28167",
    d: "M104.251,77.792h-1.993a3.132,3.132,0,0,1,2.985,3.263V97.37a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V81.055a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 222.601)",
    fill: "#f8f9fd"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28168",
    "data-name": "Path 28168",
    d: "M115.244,100.633h0a8.306,8.306,0,0,1-8.306-8.306V86.1a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 222.601)",
    fill: "#e5e7f2"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28169",
    "data-name": "Path 28169",
    d: "M111.943,77.792H109.95a3.132,3.132,0,0,1,2.985,3.263V97.37a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V81.055a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 222.601)",
    fill: "#f8f9fd"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28170",
    "data-name": "Path 28170",
    d: "M122.936,100.633h0a8.306,8.306,0,0,1-8.306-8.306V86.1a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 222.601)",
    fill: "#e5e7f2"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28171",
    "data-name": "Path 28171",
    d: "M119.636,77.792h-1.993a3.132,3.132,0,0,1,2.985,3.263V97.37a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V81.055a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 222.601)",
    fill: "#f8f9fd"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28172",
    "data-name": "Path 28172",
    d: "M99.859,112.472h0a8.306,8.306,0,0,1-8.306-8.306V97.937a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 256.478)",
    fill: "#e5e7f2"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28173",
    "data-name": "Path 28173",
    d: "M96.559,89.63H94.566a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V92.893a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 256.475)",
    fill: "#f8f9fd"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28174",
    "data-name": "Path 28174",
    d: "M107.551,112.472h0a8.306,8.306,0,0,1-8.306-8.306V97.937a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 256.478)",
    fill: "#e5e7f2"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28175",
    "data-name": "Path 28175",
    d: "M104.251,89.63h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V92.893a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 256.475)",
    fill: "#f8f9fd"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28176",
    "data-name": "Path 28176",
    d: "M107.551,112.472h0a8.306,8.306,0,0,1-8.306-8.306V97.937a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 256.478)",
    fill: "#e5e7f2"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28177",
    "data-name": "Path 28177",
    d: "M104.251,89.63h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V92.893a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 256.475)",
    fill: "#f8f9fd"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28178",
    "data-name": "Path 28178",
    d: "M115.244,112.472h0a8.306,8.306,0,0,1-8.306-8.306V97.937a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 256.478)",
    fill: "#e5e7f2"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28179",
    "data-name": "Path 28179",
    d: "M111.943,89.63H109.95a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V92.893a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 256.475)",
    fill: "#f8f9fd"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28180",
    "data-name": "Path 28180",
    d: "M122.936,112.472h0a8.306,8.306,0,0,1-8.306-8.306V97.937a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 256.478)",
    fill: "#e5e7f2"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28181",
    "data-name": "Path 28181",
    d: "M119.636,89.63h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V92.893a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 256.475)",
    fill: "#f8f9fd"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28182",
    "data-name": "Path 28182",
    d: "M99.859,124.31h0A8.306,8.306,0,0,1,91.553,116v-6.229a8.306,8.306,0,0,1,16.612,0V116a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 290.352)",
    fill: "#e5e7f2"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28183",
    "data-name": "Path 28183",
    d: "M96.559,101.469H94.566a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V104.732a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 290.352)",
    fill: "#f8f9fd"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28184",
    "data-name": "Path 28184",
    d: "M107.551,124.31h0A8.306,8.306,0,0,1,99.245,116v-6.229a8.306,8.306,0,0,1,16.612,0V116a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 290.352)",
    fill: "#e5e7f2"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28185",
    "data-name": "Path 28185",
    d: "M104.251,101.469h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V104.732a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 290.352)",
    fill: "#f8f9fd"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28186",
    "data-name": "Path 28186",
    d: "M107.551,124.31h0A8.306,8.306,0,0,1,99.245,116v-6.229a8.306,8.306,0,0,1,16.612,0V116a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 290.352)",
    fill: "#e5e7f2"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28187",
    "data-name": "Path 28187",
    d: "M104.251,101.469h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V104.732a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 290.352)",
    fill: "#f8f9fd"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28188",
    "data-name": "Path 28188",
    d: "M115.244,124.31h0A8.306,8.306,0,0,1,106.938,116v-6.229a8.306,8.306,0,0,1,16.612,0V116a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 290.352)",
    fill: "#e5e7f2"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28189",
    "data-name": "Path 28189",
    d: "M111.943,101.469H109.95a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V104.732a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 290.352)",
    fill: "#f8f9fd"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28190",
    "data-name": "Path 28190",
    d: "M122.936,124.31h0A8.306,8.306,0,0,1,114.63,116v-6.229a8.306,8.306,0,1,1,16.612,0V116a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 290.352)",
    fill: "#e5e7f2"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28191",
    "data-name": "Path 28191",
    d: "M119.636,101.469h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V104.732a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 290.352)",
    fill: "#f8f9fd"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28192",
    "data-name": "Path 28192",
    d: "M99.859,136.149h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 324.229)",
    fill: "#e5e7f2"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28193",
    "data-name": "Path 28193",
    d: "M96.559,113.308H94.566a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V116.571a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 324.229)",
    fill: "#f8f9fd"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28194",
    "data-name": "Path 28194",
    d: "M107.551,136.149h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 324.229)",
    fill: "#e5e7f2"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28195",
    "data-name": "Path 28195",
    d: "M104.251,113.308h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V116.571a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 324.229)",
    fill: "#f8f9fd"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28196",
    "data-name": "Path 28196",
    d: "M107.551,136.149h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 324.229)",
    fill: "#e5e7f2"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28197",
    "data-name": "Path 28197",
    d: "M104.251,113.308h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V116.571a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 324.229)",
    fill: "#f8f9fd"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28198",
    "data-name": "Path 28198",
    d: "M115.244,136.149h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 324.229)",
    fill: "#e5e7f2"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28199",
    "data-name": "Path 28199",
    d: "M111.943,113.308H109.95a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V116.571a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 324.229)",
    fill: "#f8f9fd"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28200",
    "data-name": "Path 28200",
    d: "M122.936,136.149h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 324.229)",
    fill: "#e5e7f2"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28201",
    "data-name": "Path 28201",
    d: "M119.636,113.308h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V116.571a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 324.229)",
    fill: "#f8f9fd"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28202",
    "data-name": "Path 28202",
    d: "M99.859,147.988h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 358.107)",
    fill: "#e5e7f2"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28203",
    "data-name": "Path 28203",
    d: "M96.559,125.147H94.566a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V128.41a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 358.107)",
    fill: "#f8f9fd"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28204",
    "data-name": "Path 28204",
    d: "M107.551,147.988h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 358.107)",
    fill: "#e5e7f2"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28205",
    "data-name": "Path 28205",
    d: "M104.251,125.147h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V128.41a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 358.107)",
    fill: "#f8f9fd"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28206",
    "data-name": "Path 28206",
    d: "M107.551,147.988h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 358.107)",
    fill: "#e5e7f2"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28207",
    "data-name": "Path 28207",
    d: "M104.251,125.147h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V128.41a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 358.107)",
    fill: "#f8f9fd"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28208",
    "data-name": "Path 28208",
    d: "M115.244,147.988h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 358.107)",
    fill: "#e5e7f2"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28209",
    "data-name": "Path 28209",
    d: "M111.943,125.147H109.95a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V128.41a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 358.107)",
    fill: "#f8f9fd"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28210",
    "data-name": "Path 28210",
    d: "M122.936,147.988h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 358.107)",
    fill: "#e5e7f2"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28211",
    "data-name": "Path 28211",
    d: "M119.636,125.147h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V128.41a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 358.107)",
    fill: "#f8f9fd"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28212",
    "data-name": "Path 28212",
    d: "M99.859,159.827h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 391.984)",
    fill: "#e5e7f2"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28213",
    "data-name": "Path 28213",
    d: "M96.559,136.986H94.566a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V140.249a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 391.984)",
    fill: "#f8f9fd"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28214",
    "data-name": "Path 28214",
    d: "M107.551,159.827h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 391.984)",
    fill: "#e5e7f2"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28215",
    "data-name": "Path 28215",
    d: "M104.251,136.986h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V140.249a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 391.984)",
    fill: "#f8f9fd"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28216",
    "data-name": "Path 28216",
    d: "M107.551,159.827h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 391.984)",
    fill: "#e5e7f2"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28217",
    "data-name": "Path 28217",
    d: "M104.251,136.986h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V140.249a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 391.984)",
    fill: "#f8f9fd"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28218",
    "data-name": "Path 28218",
    d: "M115.244,159.827h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 391.984)",
    fill: "#e5e7f2"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28219",
    "data-name": "Path 28219",
    d: "M111.943,136.986H109.95a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V140.249a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 391.984)",
    fill: "#f8f9fd"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28220",
    "data-name": "Path 28220",
    d: "M122.936,159.827h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 391.984)",
    fill: "#e5e7f2"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28221",
    "data-name": "Path 28221",
    d: "M119.636,136.986h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V140.249a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 391.984)",
    fill: "#f8f9fd"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28222",
    "data-name": "Path 28222",
    d: "M89.057,65.116h0a8.306,8.306,0,0,0,8.306-8.306V50.581a8.306,8.306,0,0,0-16.612,0V56.81a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 120.969)",
    fill: "#fff"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28223",
    "data-name": "Path 28223",
    d: "M83.739,42.275h1.993a3.132,3.132,0,0,0-2.985,3.263V61.853a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V45.538a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 120.969)",
    fill: "#bec4fa"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28224",
    "data-name": "Path 28224",
    d: "M81.364,65.116h0A8.306,8.306,0,0,0,89.67,56.81V50.581a8.306,8.306,0,0,0-16.612,0V56.81a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 120.969)",
    fill: "#e5e7f2"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28225",
    "data-name": "Path 28225",
    d: "M76.047,42.275h1.993a3.132,3.132,0,0,0-2.985,3.263V61.853a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V45.538a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 120.969)",
    fill: "#f8f9fd"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28226",
    "data-name": "Path 28226",
    d: "M81.364,65.116h0A8.306,8.306,0,0,0,89.67,56.81V50.581a8.306,8.306,0,0,0-16.612,0V56.81a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 120.969)",
    fill: "#fff"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28227",
    "data-name": "Path 28227",
    d: "M76.047,42.275h1.993a3.132,3.132,0,0,0-2.985,3.263V61.853a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V45.538a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 120.969)",
    fill: "#bec4fa"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28228",
    "data-name": "Path 28228",
    d: "M89.057,77.058h0a8.306,8.306,0,0,0,8.306-8.306V62.523a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 155.141)",
    fill: "#fff"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28229",
    "data-name": "Path 28229",
    d: "M83.739,54.217h1.993a3.132,3.132,0,0,0-2.985,3.263V73.795a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V57.48a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 155.141)",
    fill: "#bec4fa"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28230",
    "data-name": "Path 28230",
    d: "M81.364,77.058h0a8.306,8.306,0,0,0,8.306-8.306V62.523a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 155.141)",
    fill: "#e5e7f2"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28231",
    "data-name": "Path 28231",
    d: "M76.047,54.217h1.993a3.132,3.132,0,0,0-2.985,3.263V73.795a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V57.48a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 155.141)",
    fill: "#f8f9fd"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28232",
    "data-name": "Path 28232",
    d: "M81.364,77.058h0a8.306,8.306,0,0,0,8.306-8.306V62.523a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 155.141)",
    fill: "#fff"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28233",
    "data-name": "Path 28233",
    d: "M76.047,54.217h1.993a3.132,3.132,0,0,0-2.985,3.263V73.795a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V57.48a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 155.141)",
    fill: "#bec4fa"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28234",
    "data-name": "Path 28234",
    d: "M89.057,77.058h0a8.306,8.306,0,0,0,8.306-8.306V62.523a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 155.141)",
    fill: "#fff"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28235",
    "data-name": "Path 28235",
    d: "M83.739,54.217h1.993a3.132,3.132,0,0,0-2.985,3.263V73.795a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V57.48a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 155.141)",
    fill: "#bec4fa"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28236",
    "data-name": "Path 28236",
    d: "M81.364,77.058h0a8.306,8.306,0,0,0,8.306-8.306V62.523a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 155.141)",
    fill: "#e5e7f2"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28237",
    "data-name": "Path 28237",
    d: "M76.047,54.217h1.993a3.132,3.132,0,0,0-2.985,3.263V73.795a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V57.48a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 155.141)",
    fill: "#f8f9fd"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28238",
    "data-name": "Path 28238",
    d: "M81.364,77.058h0a8.306,8.306,0,0,0,8.306-8.306V62.523a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 155.141)",
    fill: "#fff"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28239",
    "data-name": "Path 28239",
    d: "M76.047,54.217h1.993a3.132,3.132,0,0,0-2.985,3.263V73.795a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V57.48a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 155.141)",
    fill: "#bec4fa"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28240",
    "data-name": "Path 28240",
    d: "M89.057,89h0a8.306,8.306,0,0,0,8.306-8.306V74.464a8.306,8.306,0,0,0-16.612,0v6.229A8.306,8.306,0,0,0,89.057,89",
    transform: "translate(231.068 189.31)",
    fill: "#fff"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28241",
    "data-name": "Path 28241",
    d: "M83.739,66.158h1.993a3.132,3.132,0,0,0-2.985,3.263V85.736A3.132,3.132,0,0,0,85.731,89H83.739a3.135,3.135,0,0,1-2.989-3.263V69.421a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 189.31)",
    fill: "#bec4fa"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28242",
    "data-name": "Path 28242",
    d: "M81.364,89h0a8.306,8.306,0,0,0,8.306-8.306V74.464a8.306,8.306,0,0,0-16.612,0v6.229A8.306,8.306,0,0,0,81.364,89",
    transform: "translate(209.055 189.31)",
    fill: "#e5e7f2"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28243",
    "data-name": "Path 28243",
    d: "M76.047,66.158h1.993a3.132,3.132,0,0,0-2.985,3.263V85.736A3.132,3.132,0,0,0,78.039,89H76.047a3.135,3.135,0,0,1-2.989-3.263V69.421a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 189.31)",
    fill: "#f8f9fd"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28244",
    "data-name": "Path 28244",
    d: "M81.364,89h0a8.306,8.306,0,0,0,8.306-8.306V74.464a8.306,8.306,0,0,0-16.612,0v6.229A8.306,8.306,0,0,0,81.364,89",
    transform: "translate(209.055 189.31)",
    fill: "#fff"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28245",
    "data-name": "Path 28245",
    d: "M76.047,66.158h1.993a3.132,3.132,0,0,0-2.985,3.263V85.736A3.132,3.132,0,0,0,78.039,89H76.047a3.135,3.135,0,0,1-2.989-3.263V69.421a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 189.31)",
    fill: "#bec4fa"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28246",
    "data-name": "Path 28246",
    d: "M89.057,100.941h0a8.306,8.306,0,0,0,8.306-8.306V86.406a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 223.482)",
    fill: "#fff"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28247",
    "data-name": "Path 28247",
    d: "M83.739,78.1h1.993a3.132,3.132,0,0,0-2.985,3.263V97.678a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V81.363A3.135,3.135,0,0,1,83.739,78.1",
    transform: "translate(231.065 223.482)",
    fill: "#bec4fa"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28248",
    "data-name": "Path 28248",
    d: "M81.364,100.941h0a8.309,8.309,0,0,0,8.31-8.306V86.406a8.308,8.308,0,0,0-16.616,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 223.482)",
    fill: "#e5e7f2"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28249",
    "data-name": "Path 28249",
    d: "M76.047,78.1h1.993a3.132,3.132,0,0,0-2.985,3.263V97.678a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V81.363A3.135,3.135,0,0,1,76.047,78.1",
    transform: "translate(209.055 223.482)",
    fill: "#f8f9fd"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28250",
    "data-name": "Path 28250",
    d: "M81.364,100.941h0a8.309,8.309,0,0,0,8.31-8.306V86.406a8.308,8.308,0,0,0-16.616,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 223.482)",
    fill: "#fff"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28251",
    "data-name": "Path 28251",
    d: "M76.047,78.1h1.993a3.132,3.132,0,0,0-2.985,3.263V97.678a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V81.363A3.135,3.135,0,0,1,76.047,78.1",
    transform: "translate(209.055 223.482)",
    fill: "#bec4fa"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28252",
    "data-name": "Path 28252",
    d: "M89.057,112.883h0a8.306,8.306,0,0,0,8.306-8.306V98.348a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 257.654)",
    fill: "#fff"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28253",
    "data-name": "Path 28253",
    d: "M83.739,90.041h1.993A3.132,3.132,0,0,0,82.746,93.3v16.315a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V93.3a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 257.651)",
    fill: "#bec4fa"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28254",
    "data-name": "Path 28254",
    d: "M81.364,112.883h0a8.306,8.306,0,0,0,8.306-8.306V98.348a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 257.654)",
    fill: "#e5e7f2"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28255",
    "data-name": "Path 28255",
    d: "M76.047,90.041h1.993A3.132,3.132,0,0,0,75.054,93.3v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V93.3a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 257.651)",
    fill: "#f8f9fd"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28256",
    "data-name": "Path 28256",
    d: "M81.364,112.883h0a8.306,8.306,0,0,0,8.306-8.306V98.348a8.306,8.306,0,1,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 257.654)",
    fill: "#fff"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28257",
    "data-name": "Path 28257",
    d: "M76.047,90.041h1.993A3.132,3.132,0,0,0,75.054,93.3v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V93.3a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 257.651)",
    fill: "#bec4fa"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28258",
    "data-name": "Path 28258",
    d: "M89.057,124.824h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 291.823)",
    fill: "#fff"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28259",
    "data-name": "Path 28259",
    d: "M83.739,101.983h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V105.246a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 291.823)",
    fill: "#bec4fa"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28260",
    "data-name": "Path 28260",
    d: "M81.364,124.824h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 291.823)",
    fill: "#e5e7f2"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28261",
    "data-name": "Path 28261",
    d: "M76.047,101.983h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V105.246a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 291.823)",
    fill: "#f8f9fd"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28262",
    "data-name": "Path 28262",
    d: "M81.364,124.824h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 291.823)",
    fill: "#fff"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28263",
    "data-name": "Path 28263",
    d: "M76.047,101.983h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V105.246a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 291.823)",
    fill: "#bec4fa"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28264",
    "data-name": "Path 28264",
    d: "M89.057,136.766h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 325.995)",
    fill: "#fff"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28265",
    "data-name": "Path 28265",
    d: "M83.739,113.925h1.993a3.132,3.132,0,0,0-2.985,3.263V133.5a3.132,3.132,0,0,0,2.985,3.263H83.739A3.135,3.135,0,0,1,80.75,133.5V117.188a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 325.995)",
    fill: "#bec4fa"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28266",
    "data-name": "Path 28266",
    d: "M81.364,136.766h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 325.995)",
    fill: "#e5e7f2"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28267",
    "data-name": "Path 28267",
    d: "M76.047,113.925h1.993a3.132,3.132,0,0,0-2.985,3.263V133.5a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V117.188a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 325.995)",
    fill: "#f8f9fd"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28268",
    "data-name": "Path 28268",
    d: "M81.364,136.766h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 325.995)",
    fill: "#fff"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28269",
    "data-name": "Path 28269",
    d: "M76.047,113.925h1.993a3.132,3.132,0,0,0-2.985,3.263V133.5a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V117.188a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 325.995)",
    fill: "#bec4fa"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28270",
    "data-name": "Path 28270",
    d: "M89.057,148.707h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0V140.4a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 360.164)",
    fill: "#fff"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28271",
    "data-name": "Path 28271",
    d: "M83.739,125.866h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V129.129a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 360.164)",
    fill: "#bec4fa"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28272",
    "data-name": "Path 28272",
    d: "M81.364,148.707h0A8.306,8.306,0,0,0,89.67,140.4v-6.229a8.306,8.306,0,1,0-16.612,0V140.4a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 360.164)",
    fill: "#e5e7f2"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28273",
    "data-name": "Path 28273",
    d: "M76.047,125.866h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V129.129a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 360.164)",
    fill: "#f8f9fd"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28274",
    "data-name": "Path 28274",
    d: "M81.364,148.707h0A8.306,8.306,0,0,0,89.67,140.4v-6.229a8.306,8.306,0,1,0-16.612,0V140.4a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 360.164)",
    fill: "#fff"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28275",
    "data-name": "Path 28275",
    d: "M76.047,125.866h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V129.129a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 360.164)",
    fill: "#bec4fa"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28276",
    "data-name": "Path 28276",
    d: "M89.057,160.649h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 394.336)",
    fill: "#fff"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28277",
    "data-name": "Path 28277",
    d: "M83.739,137.808h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V141.071a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 394.336)",
    fill: "#bec4fa"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28278",
    "data-name": "Path 28278",
    d: "M81.364,160.649h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 394.336)",
    fill: "#e5e7f2"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28279",
    "data-name": "Path 28279",
    d: "M76.047,137.808h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V141.071a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 394.336)",
    fill: "#f8f9fd"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28280",
    "data-name": "Path 28280",
    d: "M81.364,160.649h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 394.336)",
    fill: "#fff"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28281",
    "data-name": "Path 28281",
    d: "M76.047,137.808h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V141.071a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 394.336)",
    fill: "#bec4fa"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28282",
    "data-name": "Path 28282",
    d: "M99.859,185.482h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 465.395)",
    fill: "#e5e7f2"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28283",
    "data-name": "Path 28283",
    d: "M96.559,162.641H94.566a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.9a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 465.395)",
    fill: "#f8f9fd"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28284",
    "data-name": "Path 28284",
    d: "M107.551,185.482h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 465.395)",
    fill: "#e5e7f2"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28285",
    "data-name": "Path 28285",
    d: "M104.251,162.641h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.9a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 465.395)",
    fill: "#f8f9fd"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28286",
    "data-name": "Path 28286",
    d: "M107.551,185.482h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 465.395)",
    fill: "#e5e7f2"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28287",
    "data-name": "Path 28287",
    d: "M104.251,162.641h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.9a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 465.395)",
    fill: "#f8f9fd"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28288",
    "data-name": "Path 28288",
    d: "M115.244,185.482h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 465.395)",
    fill: "#e5e7f2"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28289",
    "data-name": "Path 28289",
    d: "M111.943,162.641H109.95a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.9a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 465.395)",
    fill: "#f8f9fd"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28290",
    "data-name": "Path 28290",
    d: "M122.936,185.482h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 465.395)",
    fill: "#e5e7f2"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28291",
    "data-name": "Path 28291",
    d: "M119.636,162.641h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V165.9a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 465.395)",
    fill: "#f8f9fd"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28292",
    "data-name": "Path 28292",
    d: "M89.057,185.609h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,1,0-16.612,0V177.3a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 465.759)",
    fill: "#fff"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28293",
    "data-name": "Path 28293",
    d: "M83.739,162.768h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V166.031a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 465.759)",
    fill: "#bec4fa"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28294",
    "data-name": "Path 28294",
    d: "M81.364,185.609h0A8.306,8.306,0,0,0,89.67,177.3v-6.229a8.306,8.306,0,1,0-16.612,0V177.3a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 465.759)",
    fill: "#e5e7f2"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28295",
    "data-name": "Path 28295",
    d: "M76.047,162.768h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V166.031a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 465.759)",
    fill: "#f8f9fd"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28296",
    "data-name": "Path 28296",
    d: "M81.364,185.609h0A8.306,8.306,0,0,0,89.67,177.3v-6.229a8.306,8.306,0,1,0-16.612,0V177.3a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 465.759)",
    fill: "#fff"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28297",
    "data-name": "Path 28297",
    d: "M76.047,162.768h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V166.031a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 465.759)",
    fill: "#bec4fa"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28298",
    "data-name": "Path 28298",
    d: "M99.859,173.214h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,0,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(261.978 430.29)",
    fill: "#e5e7f2"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28299",
    "data-name": "Path 28299",
    d: "M96.559,150.373H94.566a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V153.636a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(270.599 430.29)",
    fill: "#f8f9fd"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28300",
    "data-name": "Path 28300",
    d: "M107.551,173.214h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 430.29)",
    fill: "#e5e7f2"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28301",
    "data-name": "Path 28301",
    d: "M104.251,150.373h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V153.636a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 430.29)",
    fill: "#f8f9fd"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28302",
    "data-name": "Path 28302",
    d: "M107.551,173.214h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(283.988 430.29)",
    fill: "#e5e7f2"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28303",
    "data-name": "Path 28303",
    d: "M104.251,150.373h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V153.636a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(292.61 430.29)",
    fill: "#f8f9fd"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28304",
    "data-name": "Path 28304",
    d: "M115.244,173.214h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(306.002 430.29)",
    fill: "#e5e7f2"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28305",
    "data-name": "Path 28305",
    d: "M111.943,150.373H109.95a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V153.636a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(314.621 430.29)",
    fill: "#f8f9fd"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28306",
    "data-name": "Path 28306",
    d: "M122.936,173.214h0a8.306,8.306,0,0,1-8.306-8.306v-6.229a8.306,8.306,0,1,1,16.612,0v6.229a8.306,8.306,0,0,1-8.306,8.306",
    transform: "translate(328.012 430.29)",
    fill: "#e5e7f2"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28307",
    "data-name": "Path 28307",
    d: "M119.636,150.373h-1.993a3.132,3.132,0,0,1,2.985,3.263v16.315a3.132,3.132,0,0,1-2.985,3.263h1.993a3.135,3.135,0,0,0,2.989-3.263V153.636a3.135,3.135,0,0,0-2.989-3.263",
    transform: "translate(336.634 430.29)",
    fill: "#f8f9fd"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28308",
    "data-name": "Path 28308",
    d: "M89.057,173.341h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(231.068 430.654)",
    fill: "#fff"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28309",
    "data-name": "Path 28309",
    d: "M83.739,150.5h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H83.739a3.135,3.135,0,0,1-2.989-3.263V153.763a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(231.065 430.654)",
    fill: "#bec4fa"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28310",
    "data-name": "Path 28310",
    d: "M81.364,173.341h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 430.654)",
    fill: "#e5e7f2"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28311",
    "data-name": "Path 28311",
    d: "M76.047,150.5h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V153.763a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 430.654)",
    fill: "#f8f9fd"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28312",
    "data-name": "Path 28312",
    d: "M81.364,173.341h0a8.306,8.306,0,0,0,8.306-8.306v-6.229a8.306,8.306,0,0,0-16.612,0v6.229a8.306,8.306,0,0,0,8.306,8.306",
    transform: "translate(209.055 430.654)",
    fill: "#fff"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28313",
    "data-name": "Path 28313",
    d: "M76.047,150.5h1.993a3.132,3.132,0,0,0-2.985,3.263v16.315a3.132,3.132,0,0,0,2.985,3.263H76.047a3.135,3.135,0,0,1-2.989-3.263V153.763a3.135,3.135,0,0,1,2.989-3.263",
    transform: "translate(209.055 430.654)",
    fill: "#bec4fa"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28314",
    "data-name": "Path 28314",
    d: "M763.708,180.063c0,7.175-170.963,65.688-381.855,65.688S0,187.238,0,180.063s170.963-12.994,381.855-12.994,381.855,5.819,381.855,12.994",
    transform: "translate(-0.003 478.066)",
    fill: "#b6c9d4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10270",
    "data-name": "Group 10270",
    transform: "translate(373.308 655.585)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10269",
    "data-name": "Group 10269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10268",
    "data-name": "Group 10268",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28315",
    "data-name": "Path 28315",
    d: "M103.874,175.212H99.638a2.042,2.042,0,0,1-2.039-2.17l.085-1.352a2.045,2.045,0,0,1,2.039-1.915h4.066a2.042,2.042,0,0,1,2.039,1.915l.085,1.352a2.042,2.042,0,0,1-2.039,2.17",
    transform: "translate(-94.041 -169.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28316",
    "data-name": "Path 28316",
    d: "M105.2,179.87H99.441A2.042,2.042,0,0,1,97.4,177.7l.209-3.352a2.045,2.045,0,0,1,2.039-1.919h5.344a2.048,2.048,0,0,1,2.039,1.919l.209,3.352a2.042,2.042,0,0,1-2.039,2.17",
    transform: "translate(-94.605 -162.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28317",
    "data-name": "Path 28317",
    d: "M107.108,186.9H99.157a2.042,2.042,0,0,1-2.039-2.17l.421-6.707a2.038,2.038,0,0,1,2.035-1.915h7.117a2.045,2.045,0,0,1,2.039,1.915l.417,6.707a2.042,2.042,0,0,1-2.039,2.17",
    transform: "translate(-95.417 -151.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28318",
    "data-name": "Path 28318",
    d: "M110.066,198.607H98.717a2.042,2.042,0,0,1-2.039-2.17l.811-12.982a2.039,2.039,0,0,1,2.039-1.915h9.727a2.039,2.039,0,0,1,2.039,1.915l.811,12.982a2.042,2.042,0,0,1-2.039,2.17",
    transform: "translate(-96.676 -136.113)",
    fill: "#fff"
  }))))), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28319",
    "data-name": "Path 28319",
    d: "M178.319,100.473H86.574l5.487-27.424a9.776,9.776,0,0,1,9.588-7.862h61.595a9.783,9.783,0,0,1,9.592,7.862Z",
    transform: "translate(247.73 186.532)",
    fill: "#e0e0e0"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28320",
    "data-name": "Path 28320",
    d: "M180.347,102.138H86.273L91.984,73.57a10.763,10.763,0,0,1,10.526-8.63h61.595a10.763,10.763,0,0,1,10.526,8.63ZM88.6,100.226h89.413l-5.256-26.281a8.849,8.849,0,0,0-8.654-7.094H102.511a8.845,8.845,0,0,0-8.654,7.094Z",
    transform: "translate(246.869 185.825)",
    fill: "#5e7783"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2281",
    "data-name": "Rectangle 2281",
    width: 11.685,
    height: 11.878,
    transform: "translate(350.963 256.951)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2282",
    "data-name": "Rectangle 2282",
    width: 11.685,
    height: 11.878,
    transform: "translate(374.333 256.951)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2283",
    "data-name": "Rectangle 2283",
    width: 11.685,
    height: 11.878,
    transform: "translate(362.648 268.825)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2284",
    "data-name": "Rectangle 2284",
    width: 11.685,
    height: 11.878,
    transform: "translate(386.021 268.825)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2285",
    "data-name": "Rectangle 2285",
    width: 11.685,
    height: 11.878,
    transform: "translate(397.706 256.951)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28321",
    "data-name": "Path 28321",
    d: "M156.161,144.823a18.941,18.941,0,0,1,10.727-.413c6.028,1.487,65.445-3.989,61.83-32.888s-44.311-9.874-46.84-8.549-11.8,10.353-14.206,18.663-15.3,6.02-15.3,6.02Z",
    transform: "translate(436.025 273.577)",
    fill: "#fbab41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2286",
    "data-name": "Rectangle 2286",
    width: 384.755,
    height: 19.883,
    transform: "translate(178.52 644.567)",
    fill: "#0d1a38"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28322",
    "data-name": "Path 28322",
    d: "M119.267,280.522H44.7a19.617,19.617,0,0,1-19.616-19.616V159.51A19.619,19.619,0,0,1,44.7,139.894h74.569a19.617,19.617,0,0,1,19.616,19.616V260.905a19.614,19.614,0,0,1-19.616,19.616",
    transform: "translate(71.769 400.305)",
    fill: "#0d1a38"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2287",
    "data-name": "Rectangle 2287",
    width: 10.65,
    height: 136.222,
    transform: "translate(116.331 544.605)",
    fill: "#303e5e"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2288",
    "data-name": "Rectangle 2288",
    width: 10.65,
    height: 136.222,
    transform: "translate(170.156 544.605)",
    fill: "#303e5e"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2289",
    "data-name": "Rectangle 2289",
    width: 6.325,
    height: 136.222,
    transform: "translate(184.846 544.605)",
    fill: "#303e5e"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28323",
    "data-name": "Path 28323",
    d: "M52.38,213.268l11-11a2.588,2.588,0,1,0-3.661-3.661l-7.935,7.931V141.325h-4.97v65.217L38.88,198.61a2.588,2.588,0,1,0-3.661,3.661l11,11a2.462,2.462,0,0,0,.595.432V218.1l-7.932-7.932a2.589,2.589,0,1,0-3.661,3.661l11,11a2.556,2.556,0,0,0,.595.429v4.394l-7.932-7.931a2.588,2.588,0,1,0-3.661,3.661l11,11a2.465,2.465,0,0,0,.595.432V241.2l-7.932-7.932a2.588,2.588,0,1,0-3.661,3.661l11,10.994a2.466,2.466,0,0,0,.595.433v4.394l-7.932-7.931a2.588,2.588,0,1,0-3.661,3.661l11,11a2.464,2.464,0,0,0,.595.433V264.3L38.88,256.37a2.589,2.589,0,1,0-3.661,3.661l11,10.994a2.463,2.463,0,0,0,.595.432v4.97h4.97v-4.97a2.56,2.56,0,0,0,.6-.432l11-10.994a2.589,2.589,0,0,0-3.661-3.661L51.781,264.3v-4.394a2.561,2.561,0,0,0,.6-.433l11-11a2.589,2.589,0,0,0-3.661-3.661l-7.935,7.931v-4.394a2.564,2.564,0,0,0,.6-.433l11-10.994a2.588,2.588,0,1,0-3.661-3.661L51.781,241.2V236.8a2.562,2.562,0,0,0,.6-.432l11-11a2.588,2.588,0,0,0-3.661-3.661l-7.935,7.931v-4.394a2.661,2.661,0,0,0,.6-.429l11-11a2.589,2.589,0,1,0-3.661-3.661L51.781,218.1V213.7a2.56,2.56,0,0,0,.6-.432",
    transform: "translate(98.608 404.4)",
    fill: "#303e5e"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28324",
    "data-name": "Path 28324",
    d: "M161.807,280.522h74.569a19.617,19.617,0,0,0,19.616-19.616V159.51a19.619,19.619,0,0,0-19.616-19.616H161.807a19.617,19.617,0,0,0-19.616,19.616V260.905a19.614,19.614,0,0,0,19.616,19.616",
    transform: "translate(406.878 400.305)",
    fill: "#0d1a38"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2290",
    "data-name": "Rectangle 2290",
    width: 10.65,
    height: 136.222,
    transform: "translate(632.74 544.605)",
    fill: "#303e5e"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2291",
    "data-name": "Rectangle 2291",
    width: 10.65,
    height: 136.222,
    transform: "translate(578.914 544.605)",
    fill: "#303e5e"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2292",
    "data-name": "Rectangle 2292",
    width: 6.325,
    height: 136.222,
    transform: "translate(568.55 544.605)",
    fill: "#303e5e"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28325",
    "data-name": "Path 28325",
    d: "M166.354,213.268l-11-11a2.588,2.588,0,1,1,3.661-3.661l7.935,7.931V141.325h4.97v65.217l7.932-7.931a2.588,2.588,0,1,1,3.661,3.661l-11,11a2.461,2.461,0,0,1-.595.432V218.1l7.932-7.932a2.589,2.589,0,1,1,3.661,3.661l-11,11a2.554,2.554,0,0,1-.595.429v4.394l7.932-7.931a2.588,2.588,0,0,1,3.661,3.661l-11,11a2.463,2.463,0,0,1-.595.432V241.2l7.932-7.932a2.588,2.588,0,1,1,3.661,3.661l-11,10.994a2.465,2.465,0,0,1-.595.433v4.394l7.932-7.931a2.588,2.588,0,0,1,3.661,3.661l-11,11a2.462,2.462,0,0,1-.595.433V264.3l7.932-7.932a2.589,2.589,0,0,1,3.661,3.661l-11,10.994a2.461,2.461,0,0,1-.595.432v4.97h-4.97v-4.97a2.482,2.482,0,0,1-.6-.432l-11-10.994a2.589,2.589,0,0,1,3.661-3.661l7.935,7.932v-4.394a2.483,2.483,0,0,1-.6-.433l-11-11a2.588,2.588,0,0,1,3.661-3.661l7.935,7.931v-4.394a2.486,2.486,0,0,1-.6-.433l-11-10.994a2.588,2.588,0,1,1,3.661-3.661l7.935,7.932V236.8a2.484,2.484,0,0,1-.6-.432l-11-11a2.588,2.588,0,0,1,3.661-3.661l7.935,7.931v-4.394a2.577,2.577,0,0,1-.6-.429l-11-11a2.589,2.589,0,1,1,3.661-3.661l7.935,7.932V213.7a2.482,2.482,0,0,1-.6-.432",
    transform: "translate(442.379 404.4)",
    fill: "#303e5e"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28326",
    "data-name": "Path 28326",
    d: "M578.323,335.433c.483-3.132,7.306-135.986,6.985-151.239s-9.472-16.7-11.723-18.944-2.406-6.422-3.047-9.148-17.743-10.036-26.652-13.249-10.839-6.982-13.569-10.032-7.623-3.533-7.623-3.533l-74.175-27.308-142.96,1.367-142.964-1.367L88.423,129.287s-4.9.483-7.626,3.533-4.657,6.823-13.569,10.032S41.22,153.372,40.579,156.1s-.8,6.9-3.051,9.148-11.4,3.7-11.72,18.944,6.5,148.107,6.982,151.239-5.059,22.157,29.861,26.733c33.861,4.437,230.975,3.815,242.907,3.773,11.928.042,209.042.664,242.9-3.773,34.919-4.576,29.378-23.6,29.861-26.733",
    transform: "translate(73.821 291.812)",
    fill: "#fbab41"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28327",
    "data-name": "Path 28327",
    d: "M43.091,151.224a11.816,11.816,0,0,0-11.167,12.191c.467,14.647,2.413,39.1,10,47.952,12.592,14.7,82.562,9.619,98.951,7.48s37.762-47.489,31.351-61.683c-5.271-11.665-96.715-7.715-129.136-5.939",
    transform: "translate(91.331 426.717)",
    fill: "#e69730"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28328",
    "data-name": "Path 28328",
    d: "M254.68,151.032a15.429,15.429,0,0,1,14.616,16.1c-.672,14.766-2.881,36.093-9.855,44.237-12.592,14.7-82.562,9.619-98.951,7.48s-37.761-47.492-31.351-61.683c5.086-11.26,90.452-7.974,125.541-6.132",
    transform: "translate(366.193 426.716)",
    fill: "#e69730"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28329",
    "data-name": "Path 28329",
    d: "M227.237,112.584c2.73,3.051,4.657,6.823,13.565,10.036s26.011,10.515,26.652,13.245c0,0-5.7,23.443-28.185,34.17S128.553,194.289,131.8,191.868s57.223-34.533,87.806-82.817c0,0,4.9.483,7.626,3.533",
    transform: "translate(376.905 312.048)",
    fill: "#fbba64"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28330",
    "data-name": "Path 28330",
    d: "M131.74,152.584c-.3-4.136,101.128-36.808,112.2-27.281s11.283,34.6,6.48,39.19-16.091,8.518-31.552,8.333-54.323-.432-60.174-2.607-26.328-9.071-26.953-17.635",
    transform: "translate(376.969 353.595)",
    fill: "#f2edff"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28331",
    "data-name": "Path 28331",
    d: "M152.661,126.663c15.438-3.17,27.915-4.363,31.409-1.363,11.071,9.526,11.283,34.6,6.476,39.194-4.19,4.008-13.3,7.5-25.81,8.206a65.5,65.5,0,0,0-12.075-46.037",
    transform: "translate(436.837 353.594)",
    fill: "#ff9000"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28332",
    "data-name": "Path 28332",
    d: "M69.843,112.584c-2.73,3.051-4.657,6.823-13.565,10.036s-26.011,10.515-26.652,13.245c0,0,5.707,23.443,28.185,34.17s110.717,24.254,107.469,21.833-57.227-34.533-87.81-82.817c0,0-4.9.483-7.626,3.533",
    transform: "translate(84.774 312.048)",
    fill: "#fbba64"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28333",
    "data-name": "Path 28333",
    d: "M414.014,121.39c-3.356,0-144.385-17.2-158.479-18.917v-.139s-.2.027-.568.07c-.371-.042-.568-.07-.568-.07v.139C240.3,104.2,99.275,121.39,95.92,121.39c-3.533,0-52.779,7.24-52.779,7.24s72.743,77.631,98.978,86.428c35.545,2.2,105.874.22,112.848.015,6.974.2,77.3,2.189,112.848-.015,26.231-8.8,98.978-86.428,98.978-86.428s-49.245-7.24-52.779-7.24",
    transform: "translate(123.447 292.827)",
    fill: "#fbba64"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28334",
    "data-name": "Path 28334",
    d: "M43.391,112.032s71.92,17.23,199.712,17.23S471.12,111.835,465.8,112.19s-89.135-2.209-108.875-.158-106.017,2.927-106.017,2.927-76.454-5.92-87.567-6.53-49.639-.081-49.639-.081Z",
    transform: "translate(124.163 309.427)",
    fill: "#fbab41"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28335",
    "data-name": "Path 28335",
    d: "M415.773,86.161C387.839,72.677,262.611,73.638,259.719,73.638S131.6,72.677,103.665,86.161,42.016,210.427,42.016,210.427s182.668,12.434,217.7,12.434c34.4,0,217.707-12.434,217.707-12.434S443.707,99.645,415.773,86.161",
    transform: "translate(120.228 210.672)",
    fill: "#fbab41"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28336",
    "data-name": "Path 28336",
    d: "M43.391,206.465C73.677,208.5,224.306,218.54,255.784,218.54c30.911,0,182.05-10.04,212.393-12.075-5.642-17-36.6-107.33-61.3-119.185-27.2-13.063-148.3-12.133-151.1-12.133s-123.892-.931-151.1,12.133c-24.694,11.855-55.656,102.187-61.3,119.185",
    transform: "translate(124.163 214.993)",
    fill: "#a3c2e6"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28337",
    "data-name": "Path 28337",
    d: "M224.94,195.376c23.231,0,110.373-5.553,170.767-9.6-10.21-31.514-28.764-82.481-44.341-90.988C328.6,82.354,227.28,83.242,224.94,83.242s-103.662-.888-126.425,11.55c-15.577,8.511-34.136,59.486-44.345,91,60.247,4.047,147.134,9.588,170.77,9.588",
    transform: "translate(155.007 238.157)",
    fill: "#b5d8ff"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28338",
    "data-name": "Path 28338",
    d: "M215.04,157.142c20.717,0,92.274-4.418,150.355-8.24l-4.387-26.362A31.044,31.044,0,0,0,330.382,96.59H92.565a31.044,31.044,0,0,0-30.625,25.949L57.63,148.446c59.042,3.919,135.473,8.7,157.41,8.7",
    transform: "translate(164.908 276.391)",
    fill: "#8cadd1"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28339",
    "data-name": "Path 28339",
    d: "M110.108,170.024c7.31-9.26,14.878-22.327,18.917-33.688,8.677-24.424,16.4-44.585,34.912-44.824,18.512.239,26.235,20.4,34.916,44.824,6.9,19.419,24.134,24.586,32.718,26.413-36.842,2.383-85.551,5.429-121.463,7.275",
    transform: "translate(315.073 261.86)",
    fill: "#a3c3e6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10280",
    "data-name": "Group 10280",
    transform: "translate(167.558 290.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10279",
    "data-name": "Group 10279",
    clipPath: "url(#clip-path-8)"
  }, _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28340",
    "data-name": "Path 28340",
    d: "M177.22,170.024c-7.31-9.26-14.878-22.327-18.917-33.688-8.677-24.424-16.4-44.585-34.912-44.824-18.512.239-26.235,20.4-34.916,44.824-6.9,19.419-24.134,24.586-32.718,26.413,36.842,2.383,85.551,5.429,121.463,7.275",
    transform: "translate(-8.01 -28.269)",
    fill: "#a3c3e6"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28341",
    "data-name": "Path 28341",
    d: "M147.921,131.581c5.144-12.72,1.676-26.119-7.75-29.934s-21.238,3.41-26.382,16.129-1.676,26.119,7.75,29.93,21.238-3.406,26.382-16.126",
    transform: "translate(151.239 -2.182)",
    fill: "#488cea"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28342",
    "data-name": "Path 28342",
    d: "M128.894,131.581c-5.144-12.72-1.676-26.119,7.75-29.934s21.238,3.41,26.382,16.129,1.676,26.119-7.75,29.93-21.238-3.406-26.382-16.126",
    transform: "translate(194.459 -2.182)",
    fill: "#488cea"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28343",
    "data-name": "Path 28343",
    d: "M150.367,98.555h0a34.97,34.97,0,0,0-34.97,34.97v84.52h69.939v-84.52a34.97,34.97,0,0,0-34.97-34.97",
    transform: "translate(162.649 -8.115)",
    fill: "#488cea"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10275",
    "data-name": "Group 10275",
    transform: "translate(290.268 90.44)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10274",
    "data-name": "Group 10274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10273",
    "data-name": "Group 10273",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28344",
    "data-name": "Path 28344",
    d: "M141.31,124.261c12.565,0,22.748-7.368,22.748-16.458,0-.3-.039-.587-.062-.88a34.936,34.936,0,0,0-45.372,0c-.023.293-.062.583-.062.88,0,9.09,10.183,16.458,22.748,16.458",
    transform: "translate(-118.562 -98.555)",
    fill: "#fff"
  }))))), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28345",
    "data-name": "Path 28345",
    d: "M159.524,104.95a34.924,34.924,0,0,0-40.287,0c.846,8.6,9.534,15.361,20.142,15.361s19.3-6.761,20.145-15.361",
    transform: "translate(173.638 -8.115)",
    fill: "#ea9e7c"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2295",
    "data-name": "Rectangle 2295",
    width: 25.022,
    height: 26.223,
    transform: "translate(300.505 75.658)",
    fill: "#ea9e7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10278",
    "data-name": "Group 10278",
    transform: "translate(300.505 75.658)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10277",
    "data-name": "Group 10277",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10276",
    "data-name": "Group 10276",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28346",
    "data-name": "Path 28346",
    d: "M121.213,105.589a20.9,20.9,0,0,0,11.063,3.166h7.487a15.887,15.887,0,0,0,6.472-1.379V94.727H121.213Z",
    transform: "translate(-121.213 -94.727)",
    fill: "#ea9e7c"
  }))))), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28347",
    "data-name": "Path 28347",
    d: "M133.843,116.891c.239-.7,9.067-11.461,5.487-32.745-9.546-.7-11.693-5.379-10.5,1.873s2.626,14.264,2.626,14.264l1.672,8.657Z",
    transform: "translate(200.233 -55.443)",
    fill: "#0d1a38"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28348",
    "data-name": "Path 28348",
    d: "M133.581,101.616c-2.077,12.411-7.294,22.47-11.65,22.47s-6.209-10.059-4.132-22.47,7.29-22.47,11.65-22.47,6.209,10.059,4.132,22.47",
    transform: "translate(167.082 -63.654)",
    fill: "#0d1a38"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28349",
    "data-name": "Path 28349",
    d: "M133.151,97.188a8.285,8.285,0,1,0-8.287,8.287,8.288,8.288,0,0,0,8.287-8.287",
    transform: "translate(166.037 -35.74)",
    fill: "#ea9e7c"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28350",
    "data-name": "Path 28350",
    d: "M144.573,97.188a8.285,8.285,0,1,0-8.291,8.287,8.291,8.291,0,0,0,8.291-8.287",
    transform: "translate(198.721 -35.74)",
    fill: "#ea9e7c"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28351",
    "data-name": "Path 28351",
    d: "M143.927,140.5h0a25.3,25.3,0,0,1-25.3-25.3v-7.329a26.491,26.491,0,0,1,26.49-26.494h17.987v39.939a19.181,19.181,0,0,1-19.18,19.18",
    transform: "translate(171.901 -57.267)",
    fill: "#ea9e7c"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28352",
    "data-name": "Path 28352",
    d: "M143.927,140.5h0a25.3,25.3,0,0,1-25.3-25.3v-7.329a26.491,26.491,0,0,1,26.49-26.494h17.987v39.939a19.181,19.181,0,0,1-19.18,19.18",
    transform: "translate(171.901 -57.267)",
    fill: "#ea9e7c"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28353",
    "data-name": "Path 28353",
    d: "M123.291,131.585s4.908-17.74,4.726-19.192-.552-8.391-.552-8.391,15.315,1.545,21.485.819,22.018-4.34,21.292-12.326-5.673-14.921-9.943-14.3c-6.885.992-15.944-4.97-35.954,6.344-4.29,2.425,2.394,6.58.4,7.669s-6.715,29.942-6.715,29.942Z",
    transform: "translate(170.178 -68.384)",
    fill: "#0d1a38"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28354",
    "data-name": "Path 28354",
    d: "M139.284,93.87c.077-3.394-3.734.2-8.329.112s-8.237-3.823-8.318-.425,3.583,6.217,8.182,6.3,8.387-2.595,8.464-5.989",
    transform: "translate(183.363 -26.491)",
    fill: "#fff"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28355",
    "data-name": "Path 28355",
    d: "M132.084,111.3l-3.109-18.052,4.529-8.677,2.012,15.218Z",
    transform: "translate(201.503 -48.135)",
    fill: "#0d1a38"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28356",
    "data-name": "Path 28356",
    d: "M126.467,97.673s13.09.135,16.909,3.792c2.869-1.626,3.777-7.719,3.8-10.565s-4.56-9.889-4.56-9.889l-8.283-1.355-5.02,4.062-3.522,7.588Z",
    transform: "translate(192.392 -62.197)",
    fill: "#0d1a38"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28357",
    "data-name": "Path 28357",
    d: "M160.623,84.379a96.493,96.493,0,0,0-17.048-1.332c-13.1,0-23.725,1.95-23.725,4.356s10.623,4.356,23.725,4.356a91.234,91.234,0,0,0,18.176-1.56c-.4-1.935-.78-3.873-1.128-5.819",
    transform: "translate(175.392 -52.491)",
    fill: "#0d1a38"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10300",
    "data-name": "Group 10300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10299",
    "data-name": "Group 10299",
    clipPath: "url(#clip-path-11)"
  }, _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28359",
    "data-name": "Path 28359",
    d: "M124.259,141.442a28.745,28.745,0,1,1,57.266-3.572c0,.942-.05,1.877-.139,2.8,3.182-.282,6.364-.541,9.557-.726.035-.687.058-1.375.058-2.07a38.223,38.223,0,1,0-76.249,3.912c3.159-.232,6.329-.332,9.507-.34",
    transform: "translate(327.798 285.133)",
    fill: "#8cadd1"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28360",
    "data-name": "Path 28360",
    d: "M138.027,115.061a12.4,12.4,0,1,0-12.4,12.4,12.395,12.395,0,0,0,12.4-12.4",
    transform: "translate(324.023 293.777)",
    fill: "#ea9e7c"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28361",
    "data-name": "Path 28361",
    d: "M153.479,114.374a12.4,12.4,0,1,0-12.4,12.4,12.395,12.395,0,0,0,12.4-12.4",
    transform: "translate(368.239 291.812)",
    fill: "#ea9e7c"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28362",
    "data-name": "Path 28362",
    d: "M459.872,207.019c.2-.015.405-.027.606-.042.27-.015.548-.035.815-.054.1,0,.189-.012.286-.019l3.448-.228c.263-.019.517-.035.772-.054.417-.027.822-.054,1.209-.081.406-.027.8-.05,1.17-.077-.127-.386-.274-.822-.429-1.286-.166-.494-.344-1.019-.537-1.6l-.027-.073c-7.623-22.574-36.8-104.944-60.3-116.227-27.2-13.063-148.3-12.129-151.1-12.129s-123.892-.934-151.1,12.129c-24.694,11.855-55.656,102.187-61.3,119.185,2.444.166,5.688.382,9.573.641,44.26,2.954,173.883,11.438,202.821,11.438,28.7,0,161-8.654,204.087-11.523M60.053,186.267c11.681-32.908,33-86.424,50.891-95.34,26.08-13,142.161-12.071,144.841-12.071s118.76-.927,144.841,12.071c18.284,9.109,40.144,64.792,51.643,97.464-3.024,3.78-8.468,8.109-18.319,11.256-21.582,6.9-39.067-9.739-74.832-9.739s-44.392,20.647-64.178,21.153S94.031,200.663,75,197.11c-8.565-1.6-12.836-6.232-14.952-10.843",
    transform: "translate(124.163 214.996)",
    fill: "#8cadd1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2297",
    "data-name": "Rectangle 2297",
    width: 12.893,
    height: 17.554,
    transform: "translate(373.209 290.137)",
    fill: "#8cadd1"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28363",
    "data-name": "Path 28363",
    d: "M135.815,100.274H103.24A12.1,12.1,0,0,1,91.219,86.82l.344-3.054a5.375,5.375,0,0,1,5.344-4.777h45.241a5.375,5.375,0,0,1,5.344,4.777l.344,3.054a12.1,12.1,0,0,1-12.021,13.453",
    transform: "translate(260.798 226.026)",
    fill: "#8cadd1"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28364",
    "data-name": "Path 28364",
    d: "M97.011,144.823a18.941,18.941,0,0,0-10.727-.413c-6.028,1.487-65.444-3.989-61.83-32.888s44.311-9.874,46.84-8.549,11.8,10.353,14.206,18.663,15.3,6.02,15.3,6.02Z",
    transform: "translate(69.52 273.577)",
    fill: "#fbab41"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28365",
    "data-name": "Path 28365",
    d: "M297.3,134.467c-6.561-5.777-109.458-3.545-113.416-3.545S77.026,128.69,70.461,134.467c-6.453,5.692,4.217,78.3,16.674,101.183,11.635,21.377,181.861,21.377,193.5,0,12.453-22.887,23.126-95.491,16.67-101.183",
    transform: "translate(196.066 373.419)",
    fill: "#4d5873"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28366",
    "data-name": "Path 28366",
    d: "M231.432,132.638c29.957,0,64.309.711,68.009,3.97,6.456,5.692-4.213,78.3-16.67,101.186-5.815,10.685-51.281,16.029-96.746,16.029s-90.93-5.344-96.75-16.029C76.818,214.907,66.149,142.3,72.606,136.608c3.7-3.259,38.051-3.97,68.009-3.97,23.153,0,43.685.425,45.411.425s22.25-.425,45.407-.425m0-2.888c-18.211,0-34.819.263-41.909.375-1.915.031-3.136.05-3.5.05s-1.587-.019-3.5-.05c-7.094-.112-23.7-.375-41.909-.375-64.595,0-68.19,3.166-69.916,4.692-1.664,1.463-3.305,4.665-2.85,17.265A261.446,261.446,0,0,0,70.991,181.2c3.108,19.751,8.878,45.353,15.747,57.972,3.248,5.97,14.9,10.387,35.614,13.5,17.33,2.607,39.943,4.043,63.672,4.043s46.338-1.437,63.668-4.043c20.717-3.112,32.367-7.53,35.614-13.5,6.873-12.619,12.639-38.221,15.747-57.972a261.453,261.453,0,0,0,3.143-29.494c.456-12.6-1.186-15.8-2.846-17.265-1.73-1.521-5.325-4.692-69.92-4.692",
    transform: "translate(193.926 371.278)",
    fill: "#bcc7ff"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28367",
    "data-name": "Path 28367",
    d: "M179.409,139.809c2.44.039,4,.062,4.46.062s2.02-.023,4.464-.062c59.3-.907,92.324-.3,110.724.68q.127-2.41.158-4.557c-16.894-1.263-49.033-2.035-111.269-1.085-2.232.035-3.649.058-4.078.058s-1.846-.023-4.074-.058c-62.236-.95-94.375-.178-111.273,1.081q.035,2.149.162,4.56c18.4-.977,51.42-1.587,110.724-.68",
    transform: "translate(196.078 384.651)",
    fill: "#bcc7ff"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28368",
    "data-name": "Path 28368",
    d: "M188.213,136.147c-2.44.039-4,.062-4.46.062s-2.02-.023-4.464-.062c-59.3-.907-92.328-.3-110.724.68.054,1,.116,2.039.193,3.1,15.6-1.131,47.122-2.012,110.79-1.039,2.3.035,3.765.058,4.205.058s1.9-.023,4.2-.058c63.668-.977,95.189-.093,110.794,1.039.073-1.066.139-2.1.189-3.1-18.4-.977-51.423-1.587-110.724-.68",
    transform: "translate(196.198 388.312)",
    fill: "#bcc7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283",
    transform: "translate(264.762 524.013)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10281",
    "data-name": "Group 10281",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28369",
    "data-name": "Path 28369",
    d: "M188.213,136.147c-2.44.039-4,.062-4.46.062s-2.02-.023-4.464-.062c-59.3-.907-92.328-.3-110.724.68.054,1,.116,2.039.193,3.1,15.6-1.131,47.122-2.012,110.79-1.039,2.3.035,3.765.058,4.205.058s1.9-.023,4.2-.058c63.668-.977,95.189-.093,110.794,1.039.073-1.066.139-2.1.189-3.1-18.4-.977-51.423-1.587-110.724-.68",
    transform: "translate(-68.564 -135.701)",
    fill: "#bcc7ff"
  }))))), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28370",
    "data-name": "Path 28370",
    d: "M186.756,140.09c-2.224.035-3.638.058-4.062.058s-1.838-.023-4.062-.058c-60.594-.931-92.564-.212-109.7,1,.182,1.5.382,3.02.591,4.56,18.628-.927,51.323-1.475,108.724-.595,2.433.039,3.981.062,4.445.062s2.012-.023,4.445-.062c57.4-.884,90.1-.332,108.724.595q.319-2.311.595-4.56c-17.137-1.209-49.1-1.927-109.7-1",
    transform: "translate(197.254 399.65)",
    fill: "#bcc7ff"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28371",
    "data-name": "Path 28371",
    d: "M186.7,141.388c-2.433.039-3.981.062-4.445.062s-2.012-.023-4.445-.062c-57.4-.88-90.1-.328-108.724.595q.209,1.523.436,3.062c16.137-1.07,47.519-1.85,108.546-.911,2.29.035,3.75.058,4.186.058s1.9-.023,4.186-.058c61.023-.938,92.409-.158,108.546.911q.226-1.541.436-3.062c-18.628-.927-51.323-1.475-108.724-.595",
    transform: "translate(197.692 403.309)",
    fill: "#bcc7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10286",
    "data-name": "Group 10286",
    transform: "translate(266.781 544.254)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10285",
    "data-name": "Group 10285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10284",
    "data-name": "Group 10284",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28372",
    "data-name": "Path 28372",
    d: "M186.7,141.388c-2.433.039-3.981.062-4.445.062s-2.012-.023-4.445-.062c-57.4-.88-90.1-.328-108.724.595q.209,1.523.436,3.062c16.137-1.07,47.519-1.85,108.546-.911,2.29.035,3.75.058,4.186.058s1.9-.023,4.186-.058c61.023-.938,92.409-.158,108.546.911q.226-1.541.436-3.062c-18.628-.927-51.323-1.475-108.724-.595",
    transform: "translate(-69.089 -140.945)",
    fill: "#bcc7ff"
  }))))), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28373",
    "data-name": "Path 28373",
    d: "M184.481,145.331c-2.224.035-3.638.058-4.062.058s-1.838-.023-4.062-.058c-57.154-.877-88.834-.29-106.627.8.278,1.537.572,3.074.869,4.607,19.11-.83,51.261-1.27,105.376-.44,2.433.039,3.981.062,4.445.062s2.012-.023,4.445-.062c54.115-.83,86.266-.39,105.376.44q.452-2.3.869-4.607c-17.79-1.085-49.473-1.672-106.627-.8",
    transform: "translate(199.529 414.647)",
    fill: "#bcc7ff"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28374",
    "data-name": "Path 28374",
    d: "M184.219,146.63c-2.433.039-3.981.062-4.445.062s-2.012-.023-4.445-.062c-54.115-.83-86.266-.39-105.376.44.2,1,.394,2,.6,3,17.033-.954,48.164-1.572,105.036-.7,2.29.035,3.75.058,4.186.058s1.9-.023,4.186-.058c56.872-.873,88-.255,105.036.7.2-1,.4-2,.6-3-19.11-.83-51.261-1.27-105.376-.44",
    transform: "translate(200.172 418.309)",
    fill: "#bcc7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10289",
    "data-name": "Group 10289",
    transform: "translate(270.127 564.495)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10288",
    "data-name": "Group 10288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10287",
    "data-name": "Group 10287",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28375",
    "data-name": "Path 28375",
    d: "M184.219,146.63c-2.433.039-3.981.062-4.445.062s-2.012-.023-4.445-.062c-54.115-.83-86.266-.39-105.376.44.2,1,.394,2,.6,3,17.033-.954,48.164-1.572,105.036-.7,2.29.035,3.75.058,4.186.058s1.9-.023,4.186-.058c56.872-.873,88-.255,105.036.7.2-1,.4-2,.6-3-19.11-.83-51.261-1.27-105.376-.44",
    transform: "translate(-69.954 -146.186)",
    fill: "#bcc7ff"
  }))))), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28376",
    "data-name": "Path 28376",
    d: "M181.33,150.573c-2.224.035-3.638.058-4.062.058s-1.838-.023-4.062-.058c-52.856-.811-83.926-.371-102.376.56q.585,2.369,1.2,4.661c19.539-.707,50.79-1.027,100.8-.259,2.433.039,3.981.062,4.445.062s2.012-.023,4.445-.062c50.006-.768,81.257-.448,100.8.259q.608-2.288,1.2-4.661c-18.45-.931-49.52-1.371-102.376-.56",
    transform: "translate(202.679 429.647)",
    fill: "#bcc7ff"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28377",
    "data-name": "Path 28377",
    d: "M180.826,151.872c-2.433.039-3.981.062-4.445.062s-2.012-.023-4.445-.062c-50.006-.768-81.257-.448-100.8.259.266,1,.533,1.977.807,2.942,17.875-.807,48.338-1.255,100.248-.456,2.29.035,3.75.058,4.186.058s1.9-.023,4.186-.058c51.906-.8,82.373-.351,100.248.456.274-.965.541-1.95.807-2.942-19.539-.707-50.79-1.027-100.8-.259",
    transform: "translate(203.566 433.309)",
    fill: "#bcc7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10292",
    "data-name": "Group 10292",
    transform: "translate(274.708 584.735)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10291",
    "data-name": "Group 10291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10290",
    "data-name": "Group 10290",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28378",
    "data-name": "Path 28378",
    d: "M180.826,151.872c-2.433.039-3.981.062-4.445.062s-2.012-.023-4.445-.062c-50.006-.768-81.257-.448-100.8.259.266,1,.533,1.977.807,2.942,17.875-.807,48.338-1.255,100.248-.456,2.29.035,3.75.058,4.186.058s1.9-.023,4.186-.058c51.906-.8,82.373-.351,100.248.456.274-.965.541-1.95.807-2.942-19.539-.707-50.79-1.027-100.8-.259",
    transform: "translate(-71.142 -151.426)",
    fill: "#bcc7ff"
  }))))), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28379",
    "data-name": "Path 28379",
    d: "M176.889,155.812c-2.224.035-3.638.058-4.062.058s-1.838-.023-4.062-.058c-47.516-.73-77.419-.444-96.383.293.633,1.684,1.274,3.263,1.923,4.715,19.763-.552,49.446-.734,94.077-.046,2.433.039,3.981.062,4.445.062s2.012-.023,4.445-.062c44.635-.687,74.318-.506,94.077.042.649-1.448,1.29-3.027,1.923-4.711-18.964-.738-48.863-1.023-96.383-.293",
    transform: "translate(207.12 444.638)",
    fill: "#bcc7ff"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28380",
    "data-name": "Path 28380",
    d: "M175.847,157.111c-2.433.039-3.981.062-4.445.062s-2.012-.023-4.445-.062c-44.635-.684-74.318-.5-94.077.046.46,1.023.919,1.977,1.386,2.873,18.512-.618,47.519-.873,92.95-.174,2.29.035,3.75.058,4.186.058s1.9-.023,4.186-.058c45.43-.7,74.434-.444,92.95.174.463-.9.927-1.85,1.386-2.873-19.763-.552-49.446-.73-94.077-.046",
    transform: "translate(208.545 448.301)",
    fill: "#bcc7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10295",
    "data-name": "Group 10295",
    transform: "translate(281.427 604.966)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10294",
    "data-name": "Group 10294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10293",
    "data-name": "Group 10293",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28381",
    "data-name": "Path 28381",
    d: "M175.847,157.111c-2.433.039-3.981.062-4.445.062s-2.012-.023-4.445-.062c-44.635-.684-74.318-.5-94.077.046.46,1.023.919,1.977,1.386,2.873,18.512-.618,47.519-.873,92.95-.174,2.29.035,3.75.058,4.186.058s1.9-.023,4.186-.058c45.43-.7,74.434-.444,92.95.174.463-.9.927-1.85,1.386-2.873-19.763-.552-49.446-.73-94.077-.046",
    transform: "translate(-72.882 -156.665)",
    fill: "#bcc7ff"
  }))))), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28382",
    "data-name": "Path 28382",
    d: "M154.913,152.584c.3-4.136-101.128-36.808-112.2-27.281s-11.283,34.6-6.48,39.19,16.091,8.518,31.552,8.333,54.323-.432,60.174-2.607,26.328-9.071,26.953-17.635",
    transform: "translate(95.138 353.595)",
    fill: "#f2edff"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28383",
    "data-name": "Path 28383",
    d: "M74.121,126.663c-15.438-3.17-27.915-4.363-31.409-1.363-11.071,9.526-11.283,34.6-6.476,39.194,4.19,4.008,13.3,7.5,25.81,8.206a65.5,65.5,0,0,1,12.075-46.037",
    transform: "translate(95.139 353.594)",
    fill: "#ff9000"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10298",
    "data-name": "Group 10298",
    transform: "translate(261.749 290.129)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10297",
    "data-name": "Group 10297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10296",
    "data-name": "Group 10296",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28384",
    "data-name": "Path 28384",
    d: "M67.785,212.451c5.059.313,10.156.626,15.241.934,23.733-43.113,51.126-92.938,75.936-138.214-5.271.07-11.086.17-17.261.32Z",
    transform: "translate(-67.783 -75.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28385",
    "data-name": "Path 28385",
    d: "M159.329,75.134c-2.4,0-5.472,0-9.113.027L75.129,214.279q4.118.243,8.186.483c23.7-43.446,51.169-93.869,76.013-139.628",
    transform: "translate(-46.768 -75.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28386",
    "data-name": "Path 28386",
    d: "M193.778,76.934c-5.329-.463-10.831-.865-16.4-1.216l-76.056,140.91c4.607-.151,10.021-.375,16.056-.649,23.671-43,51.269-93.193,76.4-139.044",
    transform: "translate(28.183 -73.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28387",
    "data-name": "Path 28387",
    d: "M191.659,77.389c-2.73-.378-5.572-.73-8.507-1.058L109.093,213.545c2.811-.143,5.711-.3,8.681-.456,22.941-42.055,49.527-90.853,73.886-135.7",
    transform: "translate(50.419 -71.709)",
    fill: "#fff"
  }))))), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28388",
    "data-name": "Path 28388",
    d: "M169.309,140.385c-4.464,0-16.473-24.926-17.828-27.768-3.159-6.634-13.473-29.139-13.473-40.256a31.3,31.3,0,1,1,62.6,0c0,11.191-10.233,33.641-13.368,40.256-1.348,2.842-13.3,27.768-17.933,27.768",
    transform: "translate(394.908 117.493)",
    fill: "#02b6c2"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28389",
    "data-name": "Path 28389",
    d: "M168.286,58a12.735,12.735,0,1,1-12.735-12.735A12.737,12.737,0,0,1,168.286,58",
    transform: "translate(408.666 129.517)",
    fill: "#fff"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28390",
    "data-name": "Path 28390",
    d: "M72.362,136.922c-4.464,0-16.473-24.926-17.828-27.768C51.375,102.52,41.061,80.015,41.061,68.9a31.3,31.3,0,0,1,62.6,0c0,11.191-10.233,33.641-13.368,40.256-1.348,2.842-13.3,27.768-17.933,27.768",
    transform: "translate(117.496 107.583)",
    fill: "#fbab41"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28391",
    "data-name": "Path 28391",
    d: "M71.339,54.534A12.735,12.735,0,1,1,58.6,41.8,12.737,12.737,0,0,1,71.339,54.534",
    transform: "translate(131.254 119.607)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImg2);
export default __webpack_public_path__ + "static/media/banner_img2.54b6658de8a26d97b8ee2e289d13b5f7.svg";
export { ForwardRef as ReactComponent };